import * as Assets from "Data/Assets";
import * as HLF from "html-living-framework";
// import * as PIXI from "pixi.js";
import * as Constants from "Data/Constants";
import * as Topics from "Data/Topics";
import { KeyboardFocus } from "GameObjects/KeyboardFocus";

import { MainMenu } from "States/MainMenu";
import { MusicGame } from "States/MusicGame";
import { Interstitial } from "States/Interstitial";
import { LandingPage } from "States/LandingPage";
import { SplashScreen } from "States/SplashScreen";
import { MusicGameSharePopup } from "Popups/MusicGame/SharePopup";
import { MusicGamePlayback } from "States/MusicGamePlayback";

import { ChapterMenu } from "States/ChapterMenu";
import { ChapterTitleScreen } from "States/ChapterTitleScreen";
import { StoryLoadScreen } from "States/StoryLoadScreen";

import { Chapter1Page1 } from "States/Pages/Chapter1Page1";
import { Chapter1Page10 } from "States/Pages/Chapter1Page10";
import { Chapter1Page11 } from "States/Pages/Chapter1Page11";
import { Chapter1Page14 } from "States/Pages/Chapter1Page14";
import { Chapter1Page17 } from "States/Pages/Chapter1Page17";
import { Chapter1Page3 } from "States/Pages/Chapter1Page3";
import { Chapter1Page6 } from "States/Pages/Chapter1Page6";
import { Chapter1Page7 } from "States/Pages/Chapter1Page7";
import { Chapter1Page8 } from "States/Pages/Chapter1Page8";
import { Chapter1Page9 } from "States/Pages/Chapter1Page9";
import { Chapter2Page1 } from "States/Pages/Chapter2Page1";
import { Chapter2Page2 } from "States/Pages/Chapter2Page2";
import { Chapter2Page3 } from "States/Pages/Chapter2Page3";
import { Chapter2Page4 } from "States/Pages/Chapter2Page4";
import { Chapter2Page5 } from "States/Pages/Chapter2Page5";
import { Chapter2Page8 } from "States/Pages/Chapter2Page8";
import { Chapter3Page1 } from "States/Pages/Chapter3Page1";
import { Chapter3Page2 } from "States/Pages/Chapter3Page2";
import { Chapter3Page3 } from "States/Pages/Chapter3Page3";
import { Chapter3Page6 } from "States/Pages/Chapter3Page6";
import { Chapter3Page8 } from "States/Pages/Chapter3Page8";
import { Chapter4Page10 } from "States/Pages/Chapter4Page10";
import { Chapter4Page2 } from "States/Pages/Chapter4Page2";
import { Chapter4Page5 } from "States/Pages/Chapter4Page5";
import { Chapter4Page6 } from "States/Pages/Chapter4Page6";
import { Chapter4Page8 } from "States/Pages/Chapter4Page8";
import { Chapter4Page9 } from "States/Pages/Chapter4Page9";
import { Chapter5Page1 } from "States/Pages/Chapter5Page1";
import { Chapter5Page3 } from "States/Pages/Chapter5Page3";
import { Chapter5Page4 } from "States/Pages/Chapter5Page4";
import { Chapter5Page6 } from "States/Pages/Chapter5Page6";
import { Chapter5Page7 } from "States/Pages/Chapter5Page7";
import { Chapter5Page9 } from "States/Pages/Chapter5Page9";
import { Chapter5Page10 } from "States/Pages/Chapter5Page10";
import { Chapter5Page12 } from "States/Pages/Chapter5Page12";
import { Chapter5Page13 } from "States/Pages/Chapter5Page13";
import { Chapter4Page1 } from "States/Pages/Chapter4Page1";
import { Chapter5Page8 } from "States/Pages/Chapter5Page8";
import { Chapter6Page1 } from "States/Pages/Chapter6Page1";
import { Chapter6Page2 } from "States/Pages/Chapter6Page2";
import { Chapter6Page3 } from "States/Pages/Chapter6Page3";
import { Chapter6Page4 } from "States/Pages/Chapter6Page4";
import { Chapter6Page5 } from "States/Pages/Chapter6Page5";
import { Chapter6Page7 } from "States/Pages/Chapter6Page7";
import { Chapter6Page10 } from "States/Pages/Chapter6Page10";
import { Chapter6Page11 } from "States/Pages/Chapter6Page11";
import { Chapter6Page12 } from "States/Pages/Chapter6Page12";
import { Chapter6Page13 } from "States/Pages/Chapter6Page13";
import { Chapter6Page14 } from "States/Pages/Chapter6Page14";
import { Chapter6Page16 } from "States/Pages/Chapter6Page16";
import { Chapter6Page18 } from "States/Pages/Chapter6Page18";
import { Chapter5Page14 } from "States/Pages/Chapter5Page14";
import { Chapter5Page16 } from "States/Pages/Chapter5Page16";
import { Chapter7Page1 } from "States/Pages/Chapter7Page1";
import { Chapter7Page2 } from "States/Pages/Chapter7Page2";
import { Chapter7Page3 } from "States/Pages/Chapter7Page3";
import { Chapter7Page5 } from "States/Pages/Chapter7Page5";
import { Chapter7Page6 } from "States/Pages/Chapter7Page6";
import { Chapter7Page7 } from "States/Pages/Chapter7Page7";
import { TweenMax } from "gsap";
import PausePopup from "Popups/PausePopup";
import { Chapter8Page6 } from "States/Pages/Chapter8Page6";
import { Chapter8Page5 } from "States/Pages/Chapter8Page5";
import { Chapter8Page4 } from "States/Pages/Chapter8Page4";
import { Chapter8Page3 } from "States/Pages/Chapter8Page3";
import { Chapter8Page2 } from "States/Pages/Chapter8Page2";
import { Chapter8Page1 } from "States/Pages/Chapter8Page1";
import { Chapter9Page1 } from "States/Pages/Chapter9Page1";
import { Chapter9Page2 } from "States/Pages/Chapter9Page2";
import { Chapter9Page4 } from "States/Pages/Chapter9Page4";
import { Chapter9Page6 } from "States/Pages/Chapter9Page6";
import { Chapter9Page5 } from "States/Pages/Chapter9Page5";
import { Chapter10Page1 } from "States/Pages/Chapter10Page1";
import { Chapter10Page2 } from "States/Pages/Chapter10Page2";
import { Chapter10Page4 } from "States/Pages/Chapter10Page4";

export class Application extends HLF.Application {
    protected _touchManager: HLF.Input.TouchManager;
    private _paused: boolean = false;
    private _loaded: boolean = false;

    private constructor() {
        super({
            transparent: true,
            antialias: false, // better chromium performance
            preserveDrawingBuffer: (
                PIXI.utils.isMobile.android.device ||
                PIXI.utils.isMobile.amazon.device
            ) ? true : undefined,
        });
        PIXI.settings.FILTER_RESOLUTION = this.renderer.resolution;
        // enable overlay blend mode
        this.stage.filters = [new PIXI.filters.AlphaFilter()];
        this.stage.filterArea = this.screen;
        this._touchManager = new HLF.Input.TouchManager(this.renderer.plugins.interaction, this.stage);
        this._touchManager.onSwipe = (pDelta) => {
            // console.log(pDelta);
            PubSub.publishSync("swipe", pDelta);
        }
    }

    static get instance(): Application {
        if (HLF.Application._instance === undefined) {
            HLF.Application._instance = new Application();
        }
        return HLF.Application.instance as Application;
    }

    public get requiredAssets(): HLF.AssetMapData[] {
        const assets = new Array<HLF.AssetMapData>();

        assets.push(...HLF.AssetFactory(
            { "@1x": ["1"], "@2x": ["1"] },
            (i, r) => new HLF.TextureAtlasAsset("ui-" + i),
        ));

        assets.push(new HLF.FontAsset(Constants.FONT_GEL_MED_35));

        assets.push(new HLF.TextureAsset("tutorial-hand-up", "images/static/tutorial-hand-up.png"));
        assets.push(new HLF.TextureAsset("tutorial-hand-down", "images/static/tutorial-hand-down.png"));
        assets.push(new HLF.TextureAsset("tiled-bg", "images/static/tiled-bg@2x.png"));

        return assets;
    }

    public init(): void {
        super.init();

        this._stateManager.debug = false;
        this._loadManager.debug = false;
        this._popupManager.debug = false;
        this._audioManager.debug = false;

        this._resizeManager.sizeMin = new PIXI.Point(1024, 768);
        this._resizeManager.sizeMax = new PIXI.Point(1664, 768);

        this._webEventsManager.registerVisibilityChangedCallback((pVisible) => {
            if (pVisible === false && this._loadManager.children.length === 0 && this._loaded === true) {
                this.onPause(true);
            }
        });

        PubSub.subscribe(Topics.PAUSE_GAME, ()=>this.onPause(true));
        PubSub.subscribe(Topics.UNPAUSE_GAME, ()=>this.onPause(false));

        PubSub.publishSync(HLF.PUSH_KEYBOARD_LAYER, undefined);
    }

    public update(): void {
        super.update();
    }

    protected createSplashScreen(): SplashScreen {
        // override
        return new SplashScreen();
    }

    protected createAssetMap(): void {
        HLF.AssetMap.addAssetGroup(HLF.SplashScreen.NAME, [
            new HLF.FontAsset(Constants.FONT_GEL_MED_35),
        ]);
        HLF.AssetMap.addAssetGroup(Constants.STATE_LANDING_PAGE, [
            //
        ]);
        HLF.AssetMap.addAssetGroup(Constants.STATE_MENU, [
            //
        ]);
        // music game
        HLF.AssetMap.addAssetGroup(Constants.STATE_GAME, [
            new HLF.TextureAsset(Assets.MUS_BG, HLF.AssetType.JPG),
            ...Assets.SPRITESHEET_MUSIC_GAME.map(page => new HLF.TextureAtlasAsset(page)),
            ...Assets.SPRITESHEET_SPOTLIGHTS.map(page => new HLF.TextureAtlasAsset(page)),
            new HLF.AudioAsset('backing_loop_0', HLF.AudioCategory.BGM),
            new HLF.AudioAsset('backing_loop_1', HLF.AudioCategory.BGM),
            new HLF.TextureAsset('mus-ramp1', 'images/static/mus-ramp1.png'), // alternate syntax because no @1x / @2x
            new HLF.TextureAsset('mus-ramp2', 'images/static/mus-ramp2.png'),
            new HLF.TextureAsset('mus-ramp3', 'images/static/mus-ramp3.png'),
            new HLF.TextureAsset('mus-ramp4', 'images/static/mus-ramp4.png'),
            new HLF.SpineAsset("Amy Music Experience", HLF.AssetType.SPINE_JSON, "Amy Music Experience"),
            new HLF.SpineAsset("Holly Front Rig", HLF.AssetType.SPINE_JSON, "Holly Front Rig"),
            new HLF.SpineAsset("Oscar Front", HLF.AssetType.SPINE_JSON, "Oscar Front"),
            new HLF.SpineAsset("Piper Front", HLF.AssetType.SPINE_JSON, "Piper Front"),
            new HLF.SpineAsset("tyler_front_rig", HLF.AssetType.SPINE_JSON, "tyler_front_rig"),
            ...[0, 1, 2, 3, 4].map(char => new HLF.AudioAsset(`solo_${char}_0`, Constants.AUDIO_CATEGORY_SOLO)),
            ...[0, 1, 2, 3, 4].map(char => new HLF.AudioAsset(`solo_${char}_1`, Constants.AUDIO_CATEGORY_SOLO)),
            ...[0, 1, 2, 3, 4].map(char => new HLF.AudioAsset(`solo_${char}_2`, Constants.AUDIO_CATEGORY_SOLO)),
        ]);
        HLF.AssetMap.addAssetGroup(Constants.STATE_PLAYBACK, [
            new HLF.TextureAsset(Assets.MUS_BG, HLF.AssetType.JPG),
            ...Assets.SPRITESHEET_MUSIC_GAME.map(page => new HLF.TextureAtlasAsset(page)),
            ...Assets.SPRITESHEET_SPOTLIGHTS.map(page => new HLF.TextureAtlasAsset(page)),
            new HLF.AudioAsset('backing_loop_0', HLF.AudioCategory.BGM),
            new HLF.AudioAsset('backing_loop_1', HLF.AudioCategory.BGM),
            new HLF.TextureAsset('mus-ramp1', 'images/static/mus-ramp1.png'), // alternate syntax because no @1x / @2x
            new HLF.TextureAsset('mus-ramp2', 'images/static/mus-ramp2.png'),
            new HLF.TextureAsset('mus-ramp3', 'images/static/mus-ramp3.png'),
            new HLF.TextureAsset('mus-ramp4', 'images/static/mus-ramp4.png'),
            new HLF.SpineAsset("Amy Music Experience", HLF.AssetType.SPINE_JSON, "Amy Music Experience"),
            new HLF.SpineAsset("Holly Front Rig", HLF.AssetType.SPINE_JSON, "Holly Front Rig"),
            new HLF.SpineAsset("Oscar Front", HLF.AssetType.SPINE_JSON, "Oscar Front"),
            new HLF.SpineAsset("Piper Front", HLF.AssetType.SPINE_JSON, "Piper Front"),
            new HLF.SpineAsset("tyler_front_rig", HLF.AssetType.SPINE_JSON, "tyler_front_rig"),
            ...[0, 1, 2, 3, 4].map(char => new HLF.AudioAsset(`solo_${char}_0`, Constants.AUDIO_CATEGORY_SOLO)),
            ...[0, 1, 2, 3, 4].map(char => new HLF.AudioAsset(`solo_${char}_1`, Constants.AUDIO_CATEGORY_SOLO)),
            ...[0, 1, 2, 3, 4].map(char => new HLF.AudioAsset(`solo_${char}_2`, Constants.AUDIO_CATEGORY_SOLO)),
        ]);
        // debug menus
        HLF.AssetMap.addAssetGroup("ch1_menu", []);
        HLF.AssetMap.addAssetGroup("ch2_menu", []);
        HLF.AssetMap.addAssetGroup("ch3_menu", []);
        HLF.AssetMap.addAssetGroup("ch4_menu", []);
        HLF.AssetMap.addAssetGroup("ch5_menu", []);
        HLF.AssetMap.addAssetGroup("ch6_menu", []);
        HLF.AssetMap.addAssetGroup("ch7_menu", []);
        HLF.AssetMap.addAssetGroup("ch8_menu", []);
        HLF.AssetMap.addAssetGroup("ch9_menu", []);
        HLF.AssetMap.addAssetGroup("ch10_menu", []);

        // chapter 1
        HLF.AssetMap.addAssetGroup("ch1_title", [
            new HLF.TextureAsset("title-bg", "images/static/titles/title-bg.jpg"),
            new HLF.TextureAsset("hh_chaptertitle-ch1", "images/static/titles/hh_chaptertitle-ch1.png"),
            new HLF.TextureAsset("play-button", "images/static/titles/play-button.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch1_p01", [
            new HLF.TextureAsset("chp1_p01__bushes", "images/static/ch1_p01/chp1_p01__bushes.png"),
            new HLF.TextureAsset("chp1_p01_fence", "images/static/ch1_p01/chp1_p01_fence.png"),
            new HLF.TextureAsset("chp1_p01_houseback", "images/static/ch1_p01/chp1_p01_houseback.png"),
            new HLF.TextureAsset("chp1_p01_housefront", "images/static/ch1_p01/chp1_p01_housefront.png"),
            new HLF.TextureAsset("chp1_p01_lightleak", "images/static/ch1_p01/chp1_p01_lightleak.png"),
            // new HLF.TextureAsset("chp1_p01_rooster", "images/static/ch1_p01/chp1_p01_rooster.png"),
            new HLF.SpineAsset("rooster", HLF.AssetType.SPINE_JSON, "rooster"),
            new HLF.TextureAsset("chp1_p01_treeback", "images/static/ch1_p01/chp1_p01_treeback.png"),
            new HLF.TextureAsset("chp1_p01_treefront", "images/static/ch1_p01/chp1_p01_treefront.png"),
            new HLF.TextureAsset("fadinglineart", "images/static/ch1_p01/fadinglineart.png"),
            new HLF.TextureAsset("chp1_p01_sky", "images/static/ch1_p01/chp1_p01_sky.png"),
            new HLF.TextureAsset("Frame", "images/static/ch1_p01/Frame.png"),
            new HLF.AudioAsset("RoosterCall", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch1_Loop_A_Intro_v2", HLF.AudioCategory.BGM),
            new HLF.AudioAsset("HH_Ch1_Loop_A_Loop_v2", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch1_p03", [
            new HLF.TextureAsset("ch1_p03_background", "images/static/ch1_p03/ch1_p03_background.png"),
            new HLF.TextureAsset("ch1_p03_bedbottom", "images/static/ch1_p03/ch1_p03_bedbottom.png"),
            new HLF.TextureAsset("ch1_p03_bedtop", "images/static/ch1_p03/ch1_p03_bedtop.png"),
            new HLF.TextureAsset("ch1_p03_hollybase", "images/static/ch1_p03/ch1_p03_hollybase.png"),
            new HLF.TextureAsset("ch1_p03_hollyface1", "images/static/ch1_p03/ch1_p03_hollyface1.png"),
            new HLF.TextureAsset("ch1_p03_hollyface2", "images/static/ch1_p03/ch1_p03_hollyface2.png"),
            new HLF.TextureAsset("ch1_p03_hollyface3", "images/static/ch1_p03/ch1_p03_hollyface3.png"),
            new HLF.TextureAsset("Layer80", "images/static/ch1_p03/Layer80.png"),
            new HLF.TextureAsset("Layer81", "images/static/ch1_p03/Layer81.png"),
            new HLF.TextureAsset("Layer135", "images/static/ch1_p03/Layer135.png"),
            new HLF.TextureAsset("Layer135copy", "images/static/ch1_p03/Layer135copy.png"),
            new HLF.TextureAsset("Layer144", "images/static/ch1_p03/Layer144.png"),
            new HLF.TextureAsset("Layer747", "images/static/ch1_p03/Layer747.png"),
            new HLF.TextureAsset("Light", "images/static/ch1_p03/Light.png"),
            new HLF.AudioAsset("HH_Ch1_Loop_A_Intro_v2", HLF.AudioCategory.BGM),
            new HLF.AudioAsset("HH_Ch1_Loop_A_Loop_v2", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch1_p06", [
            new HLF.TextureAsset("board", "images/static/ch1_p06/board.png"),
            new HLF.TextureAsset("ch1_p06_cake", "images/static/ch1_p06/ch1_p06_cake.png"),
            new HLF.TextureAsset("ch1_p06_cal", "images/static/ch1_p06/ch1_p06_cal.png"),
            new HLF.TextureAsset("ch1_p06_calcord", "images/static/ch1_p06/ch1_p06_calcord.png"),
            new HLF.TextureAsset("ch1_p06_calpin", "images/static/ch1_p06/ch1_p06_calpin.png"),
            new HLF.TextureAsset("ch1_p06_circle", "images/static/ch1_p06/ch1_p06_circle.png"),
            new HLF.TextureAsset("ch1_p06_papers", "images/static/ch1_p06/ch1_p06_papers.png"),
            new HLF.TextureAsset("ch1_p06/ch1_p6_wcframe", "images/static/ch1_p06/ch1_p6_wcframe.png"),
            new HLF.TextureAsset("Layer48", "images/static/ch1_p06/Layer48.png"),
            new HLF.TextureAsset("stickersandpostcards", "images/static/ch1_p06/stickersandpostcards.png"),
            new HLF.AudioAsset("HH_Ch1_Loop_A_Loop_v2", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch1_p07", [
            new HLF.TextureAsset("Layer97copy", "images/static/ch1_p07/Layer97copy.png"),
            new HLF.TextureAsset("ch1_p07_background", "images/static/ch1_p07/ch1_p07_background.png"),
            new HLF.TextureAsset("ch1_p07_boots", "images/static/ch1_p07/ch1_p07_boots.png"),
            new HLF.TextureAsset("ch1_p07_jacket", "images/static/ch1_p07/ch1_p07_jacket.png"),
            new HLF.TextureAsset("ch1_p07_jackethanger", "images/static/ch1_p07/ch1_p07_jackethanger.png"),
            new HLF.TextureAsset("ch1_p07_jackethangerempty", "images/static/ch1_p07/ch1_p07_jackethangerempty.png"),
            new HLF.TextureAsset("ch1_p07_necklace", "images/static/ch1_p07/ch1_p07_necklace.png"),
            new HLF.TextureAsset("ch1_p07_necklacepolecover", "images/static/ch1_p07/ch1_p07_necklacepolecover.png"),
            new HLF.TextureAsset("ch1_p07_skirt", "images/static/ch1_p07/ch1_p07_skirt.png"),
            new HLF.TextureAsset("ch1_p07_skirthangerempty", "images/static/ch1_p07/ch1_p07_skirthangerempty.png"),
            // new HLF.TextureAsset("HollyFPO", "images/static/ch1_p07/HollyFPO.png"),
            new HLF.SpineAsset("holly-front-rig", HLF.AssetType.SPINE_JSON, "holly-front-rig"),
            new HLF.TextureAsset("Layer93", "images/static/ch1_p07/Layer93.png"),
            new HLF.TextureAsset("Layer97", "images/static/ch1_p07/Layer97.png"),
            new HLF.AudioAsset("HollyBootsOpt2", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HollyJacket", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HollyNecklaceOpt1", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HollySkirt", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch1_Loop_A_Loop_v2", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch1_p08", [
            new HLF.TextureAsset("ch1_p08/Layer196", "images/static/ch1_p08/Layer196.png"),
            new HLF.TextureAsset("ch1_p08/ch1_p6_wcframe", "images/static/ch1_p08/ch1_p6_wcframe.png"),
            new HLF.TextureAsset("ch1_p08_background", "images/static/ch1_p08/ch1_p08_background.png"),
            new HLF.TextureAsset("ch1_p08_doorframe", "images/static/ch1_p08/ch1_p08_doorframe.png"),
            new HLF.TextureAsset("ch1_p08_hollyback", "images/static/ch1_p08/ch1_p08_hollyback.png"),
            new HLF.TextureAsset("ch1_p08_hollyfront", "images/static/ch1_p08/ch1_p08_hollyfront.png"),
            new HLF.TextureAsset("ch1_p08_kitchen", "images/static/ch1_p08/ch1_p08_kitchen.png"),
            new HLF.TextureAsset("ch1_p08_stairs", "images/static/ch1_p08/ch1_p08_stairs.png"),
            new HLF.TextureAsset("ch1_p08_table", "images/static/ch1_p08/ch1_p08_table.png"),
            new HLF.AudioAsset("HH_Ch1_Loop_A_Loop_v2", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch1_p09", [
            new HLF.TextureAsset("ch1_p09_background", "images/static/ch1_p09/ch1_p09_background.png"),
            new HLF.TextureAsset("ch1_p09_holly", "images/static/ch1_p09/ch1_p09_holly.png"),
            new HLF.TextureAsset("ch1_p09_island", "images/static/ch1_p09/ch1_p09_island.png"),
            new HLF.TextureAsset("framelineart", "images/static/ch1_p09/framelineart.png"),
            new HLF.TextureAsset("Layer230", "images/static/ch1_p09/Layer230.png"),
            new HLF.TextureAsset("Layer236", "images/static/ch1_p09/Layer236.png"),
            new HLF.TextureAsset("Layer241", "images/static/ch1_p09/Layer241.png"),
            new HLF.TextureAsset("Layer241copy", "images/static/ch1_p09/Layer241copy.png"),
            new HLF.AudioAsset("HollyPhoneVibrate", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch1_Loop_A_Loop_v2", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch1_p10", [
            new HLF.TextureAsset("cp1_p10_arm", "images/static/ch1_p10/cp1_p10_arm.png"),
            new HLF.TextureAsset("cp1_p10_background", "images/static/ch1_p10/cp1_p10_background.png"),
            new HLF.TextureAsset("cp1_p10_handcover", "images/static/ch1_p10/cp1_p10_handcover.png"),
            new HLF.TextureAsset("cp1_p10_lines1", "images/static/ch1_p10/cp1_p10_lines1.png"),
            new HLF.TextureAsset("cp1_p10_phone", "images/static/ch1_p10/cp1_p10_phone.png"),
            new HLF.TextureAsset("cp1_p10_wcframe", "images/static/ch1_p10/cp1_p10_wcframe.png"),
            new HLF.AudioAsset("HollyPhoneVibrate", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch1_Loop_A_Loop_v2", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch1_p11", [
            new HLF.TextureAsset("ch1_p11_wcframe", "images/static/ch1_p11/ch1_p11_wcframe.png"),
            new HLF.TextureAsset("ch1_p11_background", "images/static/ch1_p11/ch1_p11_background.png"),
            new HLF.TextureAsset("ch1_p11_bubble", "images/static/ch1_p11/ch1_p11_bubble.png"),
            new HLF.TextureAsset("ch1_p11_emojifrown", "images/static/ch1_p11/ch1_p11_emojifrown.png"),
            new HLF.TextureAsset("ch1_p11_emojihappy", "images/static/ch1_p11/ch1_p11_emojihappy.png"),
            new HLF.TextureAsset("ch1_p11_emojiheart", "images/static/ch1_p11/ch1_p11_emojiheart.png"),
            new HLF.TextureAsset("ch1_p11_emojiheat", "images/static/ch1_p11/ch1_p11_emojiheat.png"),
            new HLF.TextureAsset("ch1_p11_emojikiss", "images/static/ch1_p11/ch1_p11_emojikiss.png"),
            new HLF.TextureAsset("ch1_p11_emojiparty", "images/static/ch1_p11/ch1_p11_emojiparty.png"),
            new HLF.TextureAsset("ch1_p11_emojisad", "images/static/ch1_p11/ch1_p11_emojisad.png"),
            new HLF.TextureAsset("ch1_p11_emojisurprise", "images/static/ch1_p11/ch1_p11_emojisurprise.png"),
            new HLF.TextureAsset("ch1_p11_emojithinking", "images/static/ch1_p11/ch1_p11_emojithinking.png"),
            new HLF.TextureAsset("ch1_p11_emojiwatch", "images/static/ch1_p11/ch1_p11_emojiwatch.png"),
            new HLF.TextureAsset("ch1_p11_holly", "images/static/ch1_p11/ch1_p11_holly.png"),
            new HLF.TextureAsset("ch1_p11_mom", "images/static/ch1_p11/ch1_p11_mom.png"),
            new HLF.AudioAsset("HH_CH1_HollyTextsMomSFX_2", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_CH1_HollyTextsMomSFX_3", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_CH1_HollyTextsMomSFX_4", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_CH1_HollyTextsMomSFX_5", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch1_Loop_A_Loop_v2", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch1_p14", [
            new HLF.TextureAsset("ch1_p14_background", "images/static/ch1_p14/ch1_p14_background.png"),
            new HLF.TextureAsset("ch1_p14_HOLLYFPO", "images/static/ch1_p14/ch1_p14_HOLLYFPO.png"),
            new HLF.TextureAsset("ch1_p14_island", "images/static/ch1_p14/ch1_p14_island.png"),
            new HLF.TextureAsset("ch1_p14_sigh", "images/static/ch1_p14/ch1_p14_sigh.png"),
            new HLF.TextureAsset("ch1_p15_chores", "images/static/ch1_p14/ch1_p15_chores.png"),
            new HLF.TextureAsset("ch1_p15_chorescounter", "images/static/ch1_p14/ch1_p15_chorescounter.png"),
            new HLF.TextureAsset("ch1_p15_HOLLYFPO", "images/static/ch1_p14/ch1_p15_HOLLYFPO.png"),
            new HLF.TextureAsset("ch1_p16_friends", "images/static/ch1_p14/ch1_p16_friends.png"),
            new HLF.TextureAsset("ch1_p16_HOLLYFPO", "images/static/ch1_p14/ch1_p16_HOLLYFPO.png"),
            new HLF.TextureAsset("Layer179", "images/static/ch1_p14/Layer179.png"),
            new HLF.TextureAsset("Layer181", "images/static/ch1_p14/Layer181.png"),
            new HLF.TextureAsset("Layer241copy", "images/static/ch1_p14/Layer241copy.png"),
            new HLF.AudioAsset("HollyChoresListOpt1", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch1_Loop_A_Loop_v2", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch1_p17", [
            new HLF.TextureAsset("ch1_p17_background", "images/static/ch1_p17/ch1_p17_background.png"),
            new HLF.TextureAsset("ch1_p17_couch", "images/static/ch1_p17/ch1_p17_couch.png"),
            new HLF.TextureAsset("ch1_p17_doorframemask", "images/static/ch1_p17/ch1_p17_doorframemask.png"),
            new HLF.TextureAsset("ch1_p17_holly", "images/static/ch1_p17/ch1_p17_holly.png"),
            new HLF.TextureAsset("ch1_p17_hollyshadow", "images/static/ch1_p17/ch1_p17_hollyshadow.png"),
            new HLF.TextureAsset("ch1_p17_outside", "images/static/ch1_p17/ch1_p17_outside.png"),
            new HLF.TextureAsset("ch1_p17_outsidelight", "images/static/ch1_p17/ch1_p17_outsidelight.png"),
            new HLF.TextureAsset("Layer9copy", "images/static/ch1_p17/Layer9copy.png"),
            new HLF.TextureAsset("Layer135", "images/static/ch1_p17/Layer135.png"),
            new HLF.TextureAsset("Layer196", "images/static/ch1_p17/Layer196.png"),
            new HLF.TextureAsset("Layer196copy", "images/static/ch1_p17/Layer196copy.png"),
            new HLF.TextureAsset("Layer196copy2", "images/static/ch1_p17/Layer196copy2.png"),
            new HLF.TextureAsset("Layer221", "images/static/ch1_p17/Layer221.png"),
            new HLF.TextureAsset("Layer223", "images/static/ch1_p17/Layer223.png"),
            new HLF.TextureAsset("Layer225", "images/static/ch1_p17/Layer225.png"),
            new HLF.TextureAsset("lines", "images/static/ch1_p17/lines.png"),
            new HLF.AudioAsset("HH_Ch1_Loop_A_Loop_v2", HLF.AudioCategory.BGM),
        ]);
        // chapter 2
        HLF.AssetMap.addAssetGroup("ch2_title", [
            new HLF.TextureAsset("title-bg", "images/static/titles/title-bg.jpg"),
            new HLF.TextureAsset("hh_chaptertitle-ch2", "images/static/titles/hh_chaptertitle-ch2.png"),
            new HLF.TextureAsset("play-button", "images/static/titles/play-button.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch2_p01", [
            new HLF.TextureAsset("ch2_p01/BGlines", "images/static/ch2_p01/BGlines.png"),
            new HLF.TextureAsset("chp2_p01_bg", "images/static/ch2_p01/chp2_p01_bg.png"),
            new HLF.TextureAsset("chp2_p01_cafe", "images/static/ch2_p01/chp2_p01_cafe.png"),
            new HLF.TextureAsset("chp2_p01_holly", "images/static/ch2_p01/chp2_p01_holly.png"),
            new HLF.TextureAsset("chp2_p01_lights", "images/static/ch2_p01/chp2_p01_lights.png"),
            new HLF.TextureAsset("ch2_p01/L", "images/static/ch2_p01/L.png"),
            new HLF.TextureAsset("ch2_p01/R", "images/static/ch2_p01/R.png"),
            new HLF.AudioAsset("HH_Ch2_CafeDoorClose_FX", HLF.AudioCategory.SFX),
        ]);

        HLF.AssetMap.addAssetGroup("ch2_p02", [
            new HLF.TextureAsset("Amy", "images/static/ch2_p02/Amy.png"),
            new HLF.TextureAsset("chairsback", "images/static/ch2_p02/chairsback.png"),
            new HLF.TextureAsset("chairsfront", "images/static/ch2_p02/chairsfront.png"),
            new HLF.TextureAsset("chp2_p02_bg", "images/static/ch2_p02/chp2_p02_bg.png"),
            new HLF.TextureAsset("chp2_p02_holly", "images/static/ch2_p02/chp2_p02_holly.png"),
            new HLF.TextureAsset("ch2_p02/L", "images/static/ch2_p02/L.png"),
            new HLF.TextureAsset("ch2_p02/linesL", "images/static/ch2_p02/linesL.png"),
            new HLF.TextureAsset("ch2_p02/linesr", "images/static/ch2_p02/linesr.png"),
            new HLF.TextureAsset("Oscar", "images/static/ch2_p02/Oscar.png"),
            new HLF.TextureAsset("Piper", "images/static/ch2_p02/Piper.png"),
            new HLF.TextureAsset("ch2_p02/R", "images/static/ch2_p02/R.png"),
            new HLF.TextureAsset("table", "images/static/ch2_p02/table.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch2_p03", [
            new HLF.TextureAsset("chp2_p03_amy", "images/static/ch2_p03/chp2_p03_amy.png"),
            new HLF.TextureAsset("chp2_p03_bg", "images/static/ch2_p03/chp2_p03_bg.png"),
            new HLF.TextureAsset("chp2_p03_chairholly", "images/static/ch2_p03/chp2_p03_chairholly.png"),
            new HLF.TextureAsset("chp2_p03_chairoscar", "images/static/ch2_p03/chp2_p03_chairoscar.png"),
            new HLF.TextureAsset("chp2_p03_holly1", "images/static/ch2_p03/chp2_p03_holly1.png"),
            new HLF.TextureAsset("chp2_p03_holly1frontarm", "images/static/ch2_p03/chp2_p03_holly1frontarm.png"),
            new HLF.TextureAsset("chp2_p03_holly2", "images/static/ch2_p03/chp2_p03_holly2.png"),
            new HLF.TextureAsset("chp2_p03_holly2phonearm", "images/static/ch2_p03/chp2_p03_holly2phonearm.png"),
            new HLF.TextureAsset("chp2_p03_holly2phoneglow", "images/static/ch2_p03/chp2_p03_holly2phoneglow.png"),
            new HLF.TextureAsset("chp2_p03_oscar", "images/static/ch2_p03/chp2_p03_oscar.png"),
            new HLF.TextureAsset("chp2_p03_oscararms", "images/static/ch2_p03/chp2_p03_oscararms.png"),
            new HLF.TextureAsset("chp2_p03_piper", "images/static/ch2_p03/chp2_p03_piper.png"),
            new HLF.TextureAsset("chp2_p03_table", "images/static/ch2_p03/chp2_p03_table.png"),
            new HLF.TextureAsset("ch2_p03/Lframe", "images/static/ch2_p03/Lframe.png"),
            new HLF.TextureAsset("ch2_p03/lines", "images/static/ch2_p03/lines.png"),
            new HLF.TextureAsset("ch2_p03/Rframe", "images/static/ch2_p03/Rframe.png"),
            // new HLF.AudioAsset("HH_Ch2_HollyPhoneVibrate_FX", HLF.AudioCategory.SFX),
        ]);

        HLF.AssetMap.addAssetGroup("ch2_p04", [
            new HLF.TextureAsset("chp2_p04_phone", "images/static/ch2_p04/chp2_p04_phone.png"),
            new HLF.TextureAsset("chp2_p04_bg", "images/static/ch2_p04/chp2_p04_bg.png"),
            new HLF.TextureAsset("ch2_p04/lFrame", "images/static/ch2_p04/lFrame.png"),
            new HLF.TextureAsset("ch2_p04/Rframe", "images/static/ch2_p04/Rframe.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch2_p05", [
            new HLF.TextureAsset("AmyFPOTHISWILLBESPINEANIM", "images/static/ch2_p05/AmyFPOTHISWILLBESPINEANIM.png"),
            new HLF.TextureAsset("chp2_p05_bgamy", "images/static/ch2_p05/chp2_p05_bgamy.png"),
            new HLF.TextureAsset("chp2_p05_bubblereveal", "images/static/ch2_p05/chp2_p05_bubblereveal.png"),
            new HLF.TextureAsset("chp2_p05_bubblestart", "images/static/ch2_p05/chp2_p05_bubblestart.png"),
            new HLF.TextureAsset("chp2_p05_chair", "images/static/ch2_p05/chp2_p05_chair.png"),
            new HLF.TextureAsset("chp2_p06_bgpiper", "images/static/ch2_p05/chp2_p06_bgpiper.png"),
            new HLF.TextureAsset("chp2_p06_bubblereveal", "images/static/ch2_p05/chp2_p06_bubblereveal.png"),
            new HLF.TextureAsset("chp2_p06_bubblestart", "images/static/ch2_p05/chp2_p06_bubblestart.png"),
            new HLF.TextureAsset("chp2_p06_chair", "images/static/ch2_p05/chp2_p06_chair.png"),
            new HLF.TextureAsset("chp2_p07_bgoscar", "images/static/ch2_p05/chp2_p07_bgoscar.png"),
            new HLF.TextureAsset("chp2_p07_bubblereveal", "images/static/ch2_p05/chp2_p07_bubblereveal.png"),
            new HLF.TextureAsset("chp2_p07_bubblestart", "images/static/ch2_p05/chp2_p07_bubblestart.png"),
            new HLF.TextureAsset("chp2_p07_chair", "images/static/ch2_p05/chp2_p07_chair.png"),
            new HLF.TextureAsset("ch2_p05/Layer162", "images/static/ch2_p05/Layer162.png"),
            new HLF.TextureAsset("ch2_p05/Lframe", "images/static/ch2_p05/Lframe.png"),
            new HLF.TextureAsset("OscarFPOTHISWILLBESPINEANIM", "images/static/ch2_p05/OscarFPOTHISWILLBESPINEANIM.png"),
            new HLF.TextureAsset("PiperFPOTHISWILLBESPINEANIM", "images/static/ch2_p05/PiperFPOTHISWILLBESPINEANIM.png"),
            new HLF.AudioAsset("HH_Ch2_OscarThoughtBubble_FX", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch2_PiperThoughtBubble_FX", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch2_ThoughtBubbleScratch1_FX", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch2_ThoughtBubbleScratch2_FX", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch2_AmyThoughtBubble_FX", HLF.AudioCategory.SFX),
        ]);

        HLF.AssetMap.addAssetGroup("ch2_p08", [
            new HLF.TextureAsset("amy", "images/static/ch2_p08/amy.png"),
            new HLF.TextureAsset("bg", "images/static/ch2_p08/bg.png"),
            new HLF.TextureAsset("chairs", "images/static/ch2_p08/chairs.png"),
            new HLF.TextureAsset("Holly", "images/static/ch2_p08/Holly.png"),
            new HLF.TextureAsset("hollyarms", "images/static/ch2_p08/hollyarms.png"),
            new HLF.TextureAsset("ch2_p08/L", "images/static/ch2_p08/L.png"),
            new HLF.TextureAsset("ch2_p08/lines", "images/static/ch2_p08/lines.png"),
            new HLF.TextureAsset("oscar", "images/static/ch2_p08/oscar.png"),
            new HLF.TextureAsset("phone", "images/static/ch2_p08/phone.png"),
            new HLF.TextureAsset("ch2_p08/R", "images/static/ch2_p08/R.png"),
            new HLF.TextureAsset("table", "images/static/ch2_p08/table.png"),
            new HLF.TextureAsset("chp2_p09_hollytablechairs", "images/static/ch2_p08/chp2_p09_hollytablechairs.png"),
            new HLF.TextureAsset("chp2_p09_sigh", "images/static/ch2_p08/chp2_p09_sigh.png"),
            new HLF.TextureAsset("chp2_p09_hollyfront", "images/static/ch2_p08/chp2_p09_hollyfront.png"),
            new HLF.TextureAsset("chp2_p09_hollyback", "images/static/ch2_p08/chp2_p09_hollyback.png"),
        ]);
        // chapter 3
        HLF.AssetMap.addAssetGroup("ch3_title", [
            new HLF.TextureAsset("title-bg", "images/static/titles/title-bg.jpg"),
            new HLF.TextureAsset("hh_chaptertitle-ch3", "images/static/titles/hh_chaptertitle-ch3.png"),
            new HLF.TextureAsset("play-button", "images/static/titles/play-button.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch3_p01", [
            new HLF.TextureAsset("BedClean", "images/static/ch3_p01/BedClean.png"),
            new HLF.TextureAsset("BedMessy", "images/static/ch3_p01/BedMessy.png"),
            new HLF.TextureAsset("chp3_p01_basket", "images/static/ch3_p01/chp3_p01_basket.png"),
            new HLF.TextureAsset("chp3_p01_basketlidoff", "images/static/ch3_p01/chp3_p01_basketlidoff.png"),
            new HLF.TextureAsset("chp3_p01_basketlidon", "images/static/ch3_p01/chp3_p01_basketlidon.png"),
            new HLF.TextureAsset("chp3_p01_bg", "images/static/ch3_p01/chp3_p01_bg.png"),
            new HLF.TextureAsset("chp3_p01_clothes", "images/static/ch3_p01/chp3_p01_clothes.png"),
            new HLF.TextureAsset("chp3_p01_flooritems", "images/static/ch3_p01/chp3_p01_flooritems.png"),
            new HLF.TextureAsset("chp3_p01_nightstand", "images/static/ch3_p01/chp3_p01_nightstand.png"),
            new HLF.TextureAsset("FrameL", "images/static/ch3_p01/FrameL.png"),
            new HLF.TextureAsset("FrameR", "images/static/ch3_p01/FrameR.png"),
            new HLF.TextureAsset("Hollychoreslist", "images/static/ch3_p01/Hollychoreslist.png"),
            new HLF.TextureAsset("LineartL", "images/static/ch3_p01/LineartL.png"),
            new HLF.TextureAsset("LineartR", "images/static/ch3_p01/LineartR.png"),

            new HLF.TextureAsset("ch3_p01/chp3_p02_list", "images/static/ch3_p02/chp3_p02_list.png"),
            new HLF.AudioAsset("HollyChoresListOpt1", HLF.AudioCategory.SFX),
        ]);

        HLF.AssetMap.addAssetGroup("ch3_p02", [
            new HLF.TextureAsset("chp3_p02_bg", "images/static/ch3_p02/chp3_p02_bg.png"),
            new HLF.TextureAsset("chp3_p02_list", "images/static/ch3_p02/chp3_p02_list.png"),
            new HLF.TextureAsset("Lframe", "images/static/ch3_p02/Lframe.png"),
            new HLF.TextureAsset("Rframe", "images/static/ch3_p02/Rframe.png"),
            new HLF.AudioAsset("HollyChoresListOpt1", HLF.AudioCategory.SFX),
        ]);

        HLF.AssetMap.addAssetGroup("ch3_p03", [
            new HLF.TextureAsset("Rlineart", "images/static/ch3_p03/Rlineart.png"),
            new HLF.TextureAsset("ch3_p03/chp3_p01_basket", "images/static/ch3_p03/chp3_p01_basket.png"),
            new HLF.TextureAsset("ch3_p03/chp3_p01_basketlidoff", "images/static/ch3_p03/chp3_p01_basketlidoff.png"),
            new HLF.TextureAsset("ch3_p03/chp3_p01_basketlidon", "images/static/ch3_p03/chp3_p01_basketlidon.png"),
            new HLF.TextureAsset("ch3_p03/chp3_p01_clothingdown", "images/static/ch3_p03/chp3_p01_clothingdown.png"),
            new HLF.TextureAsset("ch3_p03/chp3_p01_clothingup", "images/static/ch3_p03/chp3_p01_clothingup.png"),
            new HLF.TextureAsset("ch3_p03/chp3_p01_flooritemsdown", "images/static/ch3_p03/chp3_p01_flooritemsdown.png"),
            new HLF.TextureAsset("ch3_p03/chp3_p01_flooritemsup", "images/static/ch3_p03/chp3_p01_flooritemsup.png"),
            new HLF.TextureAsset("chp3_p03_bedclean", "images/static/ch3_p03/chp3_p03_bedclean.png"),
            new HLF.TextureAsset("chp3_p03_bedmessy", "images/static/ch3_p03/chp3_p03_bedmessy.png"),
            new HLF.TextureAsset("chp3_p03_nightstandclosed", "images/static/ch3_p03/chp3_p03_nightstandclosed.png"),
            new HLF.TextureAsset("chp3_p03_nightstandopen", "images/static/ch3_p03/chp3_p03_nightstandopen.png"),
            new HLF.TextureAsset("bedroom", "images/static/ch3_p03/bedroom.png"),
            new HLF.TextureAsset("bedroomcopy", "images/static/ch3_p03/bedroomcopy.png"),
            new HLF.TextureAsset("Guitar", "images/static/ch3_p03/Guitar.png"),
            // need unique ids (not just paths) so loadmanager doesn't use the same image as the previous scene
            new HLF.TextureAsset("ch3_p03/Lframe", "images/static/ch3_p03/Lframe.png"),
            new HLF.TextureAsset("ch3_p03/RFrame", "images/static/ch3_p03/RFrame.png"),

            new HLF.AudioAsset("HH_Ch3_Clothing_Pick_Up_3_FX", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch3_Clothing_Pick_Up_4_FX", HLF.AudioCategory.SFX),
        ]);

        HLF.AssetMap.addAssetGroup("ch3_p06", [
            new HLF.TextureAsset("Pixellayercopy2", "images/static/ch3_p06/Pixellayercopy2.png"),
            new HLF.TextureAsset("chp3_p06_glow", "images/static/ch3_p06/chp3_p06_glow.png"),
            new HLF.TextureAsset("chp3_p06_holly", "images/static/ch3_p06/chp3_p06_holly.png"),
            new HLF.TextureAsset("chp3_p06_wcframe_1", "images/static/ch3_p06/chp3_p06_wcframe_1.png"),
            new HLF.TextureAsset("Pixellayercopy", "images/static/ch3_p06/Pixellayercopy.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch3_p08", [
            new HLF.TextureAsset("chp3_p08_bg", "images/static/ch3_p08/chp3_p08_bg.png"),
            new HLF.TextureAsset("chp3_p08_hollyguitar", "images/static/ch3_p08/chp3_p08_hollyguitar.png"),
            new HLF.TextureAsset("Holly", "images/static/ch3_p08/Holly.png"),
            new HLF.TextureAsset("LineartL", "images/static/ch3_p08/LineartL.png"),
            new HLF.TextureAsset("LineartR", "images/static/ch3_p08/LineartR.png"),
            // TODO: dedupe/rename frame textures
            new HLF.TextureAsset("ch3_p08/Lframe", "images/static/ch3_p08/Lframe.png"),
            new HLF.TextureAsset("ch3_p08/Rframe", "images/static/ch3_p08/Rframe.png"),
        ]);

        // Chapter 4
        HLF.AssetMap.addAssetGroup("ch4_title", [
            new HLF.TextureAsset("title-bg", "images/static/titles/title-bg.jpg"),
            new HLF.TextureAsset("hh_chaptertitle-ch4", "images/static/titles/hh_chaptertitle-ch4.png"),
            new HLF.TextureAsset("play-button", "images/static/titles/play-button.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch4_p01", [
            new HLF.SpineAsset("Holly Front Rig", HLF.AssetType.SPINE_JSON, "Holly Front Rig"),
            new HLF.TextureAsset("1", "images/static/ch4_p01/_1.png"),
            new HLF.TextureAsset("1Blue", "images/static/ch4_p01/_1Blue.png"),
            new HLF.TextureAsset("1Yellow", "images/static/ch4_p01/_1Yellow.png"),
            new HLF.TextureAsset("2", "images/static/ch4_p01/_2.png"),
            new HLF.TextureAsset("2Red_1", "images/static/ch4_p01/_2Red_1.png"),
            new HLF.TextureAsset("2Red", "images/static/ch4_p01/_2Red.png"),
            new HLF.TextureAsset("3", "images/static/ch4_p01/_3.png"),
            new HLF.TextureAsset("3copy", "images/static/ch4_p01/_3copy.png"),
            new HLF.TextureAsset("4Yellow", "images/static/ch4_p01/_4Yellow.png"),
            new HLF.TextureAsset("5blue_1", "images/static/ch4_p01/_5blue_1.png"),
            new HLF.TextureAsset("5blue", "images/static/ch4_p01/_5blue.png"),
            new HLF.TextureAsset("5Red", "images/static/ch4_p01/_5Red.png"),
            new HLF.TextureAsset("5Yellow", "images/static/ch4_p01/_5Yellow.png"),
            new HLF.TextureAsset("egmusbtnvar1", "images/static/ch4_p01/egmusbtnvar1.png"),
            new HLF.TextureAsset("egmusbtnvar2", "images/static/ch4_p01/egmusbtnvar2.png"),
            new HLF.TextureAsset("egmusbtnvar3", "images/static/ch4_p01/egmusbtnvar3.png"),
            new HLF.TextureAsset("Layer0", "images/static/ch4_p01/Layer0.png"),
            new HLF.TextureAsset("Section1", "images/static/ch4_p01/Section1.png"),
            new HLF.TextureAsset("Section2", "images/static/ch4_p01/Section2.png"),
            new HLF.TextureAsset("Section3", "images/static/ch4_p01/Section3.png"),
            new HLF.AudioAsset("ch4_p01_red_1", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("ch4_p01_red_2", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("ch4_p01_red_3", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("ch4_p01_blue_1", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("ch4_p01_blue_2", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("ch4_p01_blue_3", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("ch4_p01_yellow_1", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("ch4_p01_yellow_2", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("ch4_p01_yellow_3", HLF.AudioCategory.SFX),
        ]);

        HLF.AssetMap.addAssetGroup("ch4_p02", [
            new HLF.TextureAsset("chp4_p02_basket", "images/static/ch4_p02/chp4_p02_basket.png"),
            new HLF.TextureAsset("chp4_p02_bg", "images/static/ch4_p02/chp4_p02_bg.png"),
            new HLF.TextureAsset("chp4_p02_guitarstand", "images/static/ch4_p02/chp4_p02_guitarstand.png"),
            new HLF.TextureAsset("chp4_p02_hollyp2", "images/static/ch4_p02/chp4_p02_hollyp2.png"),
            new HLF.TextureAsset("chp4_p02_hollyp3", "images/static/ch4_p02/chp4_p02_hollyp3.png"),
            new HLF.TextureAsset("chp4_p02_hollyp4", "images/static/ch4_p02/chp4_p02_hollyp4.png"),
            new HLF.TextureAsset("Llineart", "images/static/ch4_p02/Llineart.png"),
            new HLF.TextureAsset("Pixellayercopy", "images/static/ch4_p02/Pixellayercopy.png"),
            new HLF.TextureAsset("Pixellayercopy2", "images/static/ch4_p02/Pixellayercopy2.png"),
            new HLF.TextureAsset("Rlineart", "images/static/ch4_p02/Rlineart.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch4_p05", [
            new HLF.TextureAsset("amys", "images/static/ch4_p05/amys.png"),
            new HLF.TextureAsset("chp4_p05_amy", "images/static/ch4_p05/chp4_p05_amy.png"),
            new HLF.TextureAsset("chp4_p05_arrow", "images/static/ch4_p05/chp4_p05_arrow.png"),
            new HLF.TextureAsset("chp4_p05_bg", "images/static/ch4_p05/chp4_p05_bg.png"),
            new HLF.TextureAsset("chp4_p05_bookbottom", "images/static/ch4_p05/chp4_p05_bookbottom.png"),
            new HLF.TextureAsset("chp4_p05_booktop", "images/static/ch4_p05/chp4_p05_booktop.png"),
            new HLF.TextureAsset("chp4_p05_close", "images/static/ch4_p05/chp4_p05_close.png"),
            new HLF.TextureAsset("chp4_p05_darkoverlay", "images/static/ch4_p05/chp4_p05_darkoverlay.png"),
            new HLF.TextureAsset("chp4_p05_oscar", "images/static/ch4_p05/chp4_p05_oscar.png"),
            new HLF.TextureAsset("chp4_p05_piper", "images/static/ch4_p05/chp4_p05_piper.png"),
            new HLF.TextureAsset("section4", "images/static/ch4_p05/section4.png"),
            new HLF.TextureAsset("section3", "images/static/ch4_p05/section3.png"),
            new HLF.TextureAsset("section2", "images/static/ch4_p05/section2.png"),
            new HLF.TextureAsset("section1", "images/static/ch4_p05/section1.png"),
            new HLF.TextureAsset("chp4_p05_sticker1", "images/static/ch4_p05/chp4_p05_sticker1.png"),
            new HLF.TextureAsset("chp4_p05_sticker2", "images/static/ch4_p05/chp4_p05_sticker2.png"),
            new HLF.TextureAsset("chp4_p05_sticker3", "images/static/ch4_p05/chp4_p05_sticker3.png"),
            new HLF.TextureAsset("chp4_p05_sticker4", "images/static/ch4_p05/chp4_p05_sticker4.png"),
            new HLF.TextureAsset("chp4_p05_tyler", "images/static/ch4_p05/chp4_p05_tyler.png"),
            new HLF.TextureAsset("chp4_p05_whiteborder", "images/static/ch4_p05/chp4_p05_whiteborder.png"),
            new HLF.TextureAsset("ch4_p05/L", "images/static/ch4_p05/L.png"),
            new HLF.TextureAsset("Oscars", "images/static/ch4_p05/Oscars.png"),
            new HLF.TextureAsset("piper", "images/static/ch4_p05/piper.png"),
            new HLF.TextureAsset("ch4_p05/R", "images/static/ch4_p05/R.png"),
            new HLF.TextureAsset("tylers", "images/static/ch4_p05/tylers.png"),
            new HLF.TextureAsset("stickerMask", "images/static/ch4_p05/stickerMask.png"),
            // the following images are not in the adobe animate source file
            new HLF.TextureAsset("chp4_p05_sticker1_shadow", "images/static/ch4_p05/chp4_p05_sticker1_shadow.png"),
            new HLF.TextureAsset("chp4_p05_sticker2_shadow", "images/static/ch4_p05/chp4_p05_sticker2_shadow.png"),
            new HLF.TextureAsset("chp4_p05_sticker3_shadow", "images/static/ch4_p05/chp4_p05_sticker3_shadow.png"),
            new HLF.TextureAsset("chp4_p05_sticker4_shadow", "images/static/ch4_p05/chp4_p05_sticker4_shadow.png"),
            new HLF.TextureAsset("chp4_p05_sticker5", "images/static/ch4_p05/chp4_p05_sticker5.png"),
            new HLF.TextureAsset("chp4_p05_sticker5_shadow", "images/static/ch4_p05/chp4_p05_sticker5_shadow.png"),
            new HLF.TextureAsset("chp4_p05_sticker6", "images/static/ch4_p05/chp4_p05_sticker6.png"),
            new HLF.TextureAsset("chp4_p05_sticker6_shadow", "images/static/ch4_p05/chp4_p05_sticker6_shadow.png"),
            new HLF.TextureAsset("chp4_p05_sticker7", "images/static/ch4_p05/chp4_p05_sticker7.png"),
            new HLF.TextureAsset("chp4_p05_sticker7_shadow", "images/static/ch4_p05/chp4_p05_sticker7_shadow.png"),
            new HLF.TextureAsset("chp4_p05_sticker8", "images/static/ch4_p05/chp4_p05_sticker8.png"),
            new HLF.TextureAsset("chp4_p05_sticker8_shadow", "images/static/ch4_p05/chp4_p05_sticker8_shadow.png"),

            new HLF.AudioAsset("HH_Ch4_Scrapbook_Page_Turn_3_FX", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch4_Scrapbook_Page_Turn_1_FX", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch4_Scrapbook_Page_Turn_2_FX", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch4_Scrapbook_Music", HLF.AudioCategory.SFX),

        ]);

        HLF.AssetMap.addAssetGroup("ch4_p06", [
            new HLF.TextureAsset("chp4_p06_bg", "images/static/ch4_p06/chp4_p06_bg.png"),
            new HLF.TextureAsset("chp4_p06_holly1", "images/static/ch4_p06/chp4_p06_holly1.png"),
            new HLF.TextureAsset("chp4_p06_holly2", "images/static/ch4_p06/chp4_p06_holly2.png"),
            new HLF.TextureAsset("ch4_p06/L", "images/static/ch4_p06/L.png"),
            new HLF.TextureAsset("ch4_p06/R", "images/static/ch4_p06/R.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch4_p08", [
            new HLF.TextureAsset("chp4_p08_basket", "images/static/ch4_p08/chp4_p08_basket.png"),
            new HLF.TextureAsset("chp4_p08_bg", "images/static/ch4_p08/chp4_p08_bg.png"),
            new HLF.TextureAsset("chp4_p08_guitar", "images/static/ch4_p08/chp4_p08_guitar.png"),
            new HLF.TextureAsset("chp4_p08_holly", "images/static/ch4_p08/chp4_p08_holly.png"),
            new HLF.TextureAsset("ch4_p08/L", "images/static/ch4_p08/L.png"),
            new HLF.TextureAsset("lines", "images/static/ch4_p08/lines.png"),
            new HLF.TextureAsset("ch4_p08/R", "images/static/ch4_p08/R.png"),

            // "preused" assets from next scene
            new HLF.TextureAsset("ch4_p08/chp4_p09_notification", "images/static/ch4_p09/chp4_p09_notification.png"),
            new HLF.TextureAsset("ch4_p08/chp4_p09_phone", "images/static/ch4_p09/chp4_p09_phone.png"),
            new HLF.TextureAsset("ch4_p08/chp4_p09_shine", "images/static/ch4_p09/chp4_p09_shine.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch4_p09", [
            new HLF.TextureAsset("chp4_p09_bg", "images/static/ch4_p09/chp4_p09_bg.png"),
            new HLF.TextureAsset("chp4_p09_notification", "images/static/ch4_p09/chp4_p09_notification.png"),
            new HLF.TextureAsset("chp4_p09_phone", "images/static/ch4_p09/chp4_p09_phone.png"),
            new HLF.TextureAsset("chp4_p09_shine", "images/static/ch4_p09/chp4_p09_shine.png"),

            new HLF.TextureAsset("ch4_p09/L", "images/static/ch4_p09/L.png"),
            new HLF.TextureAsset("ch4_p09/R", "images/static/ch4_p09/R.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch4_p10", [
            new HLF.TextureAsset("chp4_p10_basket", "images/static/ch4_p10/chp4_p10_basket.png"),
            new HLF.TextureAsset("chp4_p10_bg", "images/static/ch4_p10/chp4_p10_bg.png"),
            new HLF.TextureAsset("chp4_p10_guitar", "images/static/ch4_p10/chp4_p10_guitar.png"),
            new HLF.TextureAsset("chp4_p10_hollyguitar", "images/static/ch4_p10/chp4_p10_hollyguitar.png"),
            new HLF.TextureAsset("chp4_p10_sigh", "images/static/ch4_p10/chp4_p10_sigh.png"),
            new HLF.TextureAsset("ch4_p10/L", "images/static/ch4_p10/L.png"),
            new HLF.TextureAsset("Llines", "images/static/ch4_p10/Llines.png"),
            new HLF.TextureAsset("ch4_p10/R", "images/static/ch4_p10/R.png"),
            new HLF.TextureAsset("chp4_p11_holly", "images/static/ch4_p10/chp4_p11_holly.png"),
            new HLF.TextureAsset("chp4_p10_doorclosed", "images/static/ch4_p10/chp4_p10_doorclosed.png"),
            new HLF.TextureAsset("chp4_p11_dooropen", "images/static/ch4_p10/chp4_p11_dooropen.png"),

        ]);

        // Chapter 5
        HLF.AssetMap.addAssetGroup("ch5_title", [
            new HLF.TextureAsset("title-bg", "images/static/titles/title-bg.jpg"),
            new HLF.TextureAsset("hh_chaptertitle-ch5", "images/static/titles/hh_chaptertitle-ch5.png"),
            new HLF.TextureAsset("play-button", "images/static/titles/play-button.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch5_p01", [
            new HLF.TextureAsset("chp5_p01_bg", "images/static/ch5_p01/chp5_p01_bg.png"),
            new HLF.TextureAsset("chp5_p01_hollyback", "images/static/ch5_p01/chp5_p01_hollyback.png"),
            new HLF.TextureAsset("chp5_p01_hollyfront", "images/static/ch5_p01/chp5_p01_hollyfront.png"),
            new HLF.TextureAsset("chp5_p01_lamb", "images/static/ch5_p01/chp5_p01_lamb.png"),
            new HLF.TextureAsset("chp5_p01_penfront", "images/static/ch5_p01/chp5_p01_penfront.png"),
            new HLF.TextureAsset("chp5_p01_penside", "images/static/ch5_p01/chp5_p01_penside.png"),
            new HLF.TextureAsset("chp5_p02_holly", "images/static/ch5_p01/chp5_p02_holly.png"),
            new HLF.TextureAsset("chp5_p02_lamb", "images/static/ch5_p01/chp5_p02_lamb.png"),
            new HLF.TextureAsset("chp5_p02_penside", "images/static/ch5_p01/chp5_p02_penside.png"),
            new HLF.TextureAsset("ch5_p01/Lframe", "images/static/ch5_p01/Lframe.png"),
            new HLF.TextureAsset("ch5_p01/Llinescopy", "images/static/ch5_p01/Llinescopy.png"),
            new HLF.TextureAsset("ch5_p01/Rframe", "images/static/ch5_p01/Rframe.png"),
            new HLF.TextureAsset("ch5_p01/Rlines", "images/static/ch5_p01/Rlines.png"),

            new HLF.AudioAsset("HH_Ch5_Intro_P1", HLF.AudioCategory.BGM),
            new HLF.AudioAsset("HH_Ch5_LoopA_P1-5", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch5_p03", [
            new HLF.TextureAsset("chp5_p03_bg", "images/static/ch5_p03/chp5_p03_bg.png"),
            new HLF.TextureAsset("chp5_p03_holly", "images/static/ch5_p03/chp5_p03_holly.png"),
            new HLF.TextureAsset("chp5_p03_light", "images/static/ch5_p03/chp5_p03_light.png"),
            new HLF.TextureAsset("ch5_p03/Lframe", "images/static/ch5_p03/Lframe.png"),
            new HLF.TextureAsset("ch5_p03/Llines", "images/static/ch5_p03/Llines.png"),
            new HLF.TextureAsset("ch5_p03/Rframe", "images/static/ch5_p03/Rframe.png"),
            new HLF.TextureAsset("ch5_p03/rlines", "images/static/ch5_p03/rlines.png"),

            new HLF.AudioAsset("HH_Ch5_Intro_P1", HLF.AudioCategory.BGM),
            new HLF.AudioAsset("HH_Ch5_LoopA_P1-5", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch5_p04", [
            new HLF.TextureAsset("blanket", "images/static/ch5_p04/blanket.png"),
            new HLF.TextureAsset("chp5_p04_apple", "images/static/ch5_p04/chp5_p04_apple.png"),
            new HLF.TextureAsset("chp5_p04_bg", "images/static/ch5_p04/chp5_p04_bg.png"),
            new HLF.TextureAsset("chp5_p04_brush", "images/static/ch5_p04/chp5_p04_brush.png"),
            new HLF.TextureAsset("chp5_p04_hollyback", "images/static/ch5_p04/chp5_p04_hollyback.png"),
            new HLF.TextureAsset("chp5_p04_hollyfront", "images/static/ch5_p04/chp5_p04_hollyfront.png"),
            new HLF.TextureAsset("chp5_p04_saddlerope", "images/static/ch5_p04/chp5_p04_saddlerope.png"),
            // new HLF.TextureAsset("horse", "images/static/ch5_p04/horse.png"),
            new HLF.SpineAsset("holly-horse", HLF.AssetType.SPINE_JSON, "holly-horse"),
            new HLF.TextureAsset("ch5_p04/Lframe", "images/static/ch5_p04/Lframe.png"),
            new HLF.TextureAsset("ch5_p04/Rframe", "images/static/ch5_p04/Rframe.png"),
            new HLF.TextureAsset("saddle", "images/static/ch5_p04/saddle.png"),

            // these three assets are not in the .fla
            new HLF.TextureAsset("apple_whole", "images/static/ch5_p04/apple_whole.png"),
            new HLF.TextureAsset("apple_eaten", "images/static/ch5_p04/apple_eaten.png"),
            new HLF.TextureAsset("apple_part_eaten", "images/static/ch5_p04/apple_part_eaten.png"),

            new HLF.AudioAsset("HH_Ch5_Horse_Brush_P5_FX", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch5_Horse_Chomp_Apple_P5_FX", HLF.AudioCategory.SFX),
            new HLF.AudioAsset("HH_Ch5_Horse_Saddle_P5_FX", HLF.AudioCategory.SFX),

            new HLF.AudioAsset("HH_Ch5_Intro_P1", HLF.AudioCategory.BGM),
            new HLF.AudioAsset("HH_Ch5_LoopA_P1-5", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch5_p06", [
            new HLF.TextureAsset("ch5_p06_bg", "images/static/ch5_p06/ch5_p06_bg.png"),
            new HLF.TextureAsset("ch5_p06_butterfly1", "images/static/ch5_p06/ch5_p06_butterfly1.png"),
            new HLF.TextureAsset("ch5_p06_butterfly2", "images/static/ch5_p06/ch5_p06_butterfly2.png"),
            new HLF.TextureAsset("ch5_p06_butterfly3", "images/static/ch5_p06/ch5_p06_butterfly3.png"),
            new HLF.TextureAsset("ch5_p06_butterfly4", "images/static/ch5_p06/ch5_p06_butterfly4.png"),
            new HLF.TextureAsset("ch5_p06_hollyhorse", "images/static/ch5_p06/ch5_p06_hollyhorse.png"),
            new HLF.TextureAsset("ch5_p06/Lframe", "images/static/ch5_p06/Lframe.png"),
            new HLF.TextureAsset("ch5_p06/llines", "images/static/ch5_p06/llines.png"),
            new HLF.TextureAsset("ch5_p06/Rframe", "images/static/ch5_p06/Rframe.png"),
            new HLF.TextureAsset("ch5_p06/rlijnes", "images/static/ch5_p06/rlijnes.png"),

            new HLF.AudioAsset("HH_Ch5_LoopA_P1-5", HLF.AudioCategory.BGM),
            new HLF.AudioAsset("HH_Ch5_Holly_On_Horseback_LoopB_P6-9", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch5_p07", [
            new HLF.TextureAsset("ch5_p07_bg", "images/static/ch5_p07/ch5_p07_bg.png"),
            new HLF.TextureAsset("ch5_p07_butterfly", "images/static/ch5_p07/ch5_p07_butterfly.png"),
            new HLF.TextureAsset("ch5_p07_hollyhorse", "images/static/ch5_p07/ch5_p07_hollyhorse.png"),
            new HLF.TextureAsset("Layer294copy", "images/static/ch5_p07/Layer294copy.png"),
            new HLF.TextureAsset("ch5_p07/Lframe", "images/static/ch5_p07/Lframe.png"),
            new HLF.TextureAsset("nolines", "images/static/ch5_p07/nolines.png"),
            new HLF.TextureAsset("ch5_p07/Rframe", "images/static/ch5_p07/Rframe.png"),

            new HLF.AudioAsset("HH_Ch5_Holly_On_Horseback_LoopB_P6-9", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch5_p08", [
            new HLF.TextureAsset("Layer1267", "images/static/ch5_p08/Layer1267.png"),
            new HLF.TextureAsset("1", "images/static/ch5_p08/_1.png"),
            new HLF.TextureAsset("two", "images/static/ch5_p08/two.png"),
            new HLF.TextureAsset("3", "images/static/ch5_p08/_3.png"),
            new HLF.TextureAsset("4", "images/static/ch5_p08/_4.png"),
            new HLF.TextureAsset("5_1_1", "images/static/ch5_p08/_5_1_1.png"),
            new HLF.TextureAsset("5_1", "images/static/ch5_p08/_5_1.png"),
            new HLF.TextureAsset("5_2", "images/static/ch5_p08/_5_2.png"),
            new HLF.TextureAsset("5_3", "images/static/ch5_p08/_5_3.png"),
            new HLF.TextureAsset("5", "images/static/ch5_p08/_5.png"),
            new HLF.TextureAsset("5copy_1", "images/static/ch5_p08/_5copy_1.png"),
            new HLF.TextureAsset("5copy_2", "images/static/ch5_p08/_5copy_2.png"),
            new HLF.TextureAsset("5copy", "images/static/ch5_p08/_5copy.png"),
            new HLF.TextureAsset("6", "images/static/ch5_p08/_6.png"),
            new HLF.TextureAsset("7", "images/static/ch5_p08/_7.png"),
            new HLF.TextureAsset("9", "images/static/ch5_p08/_9.png"),
            new HLF.TextureAsset("bush1", "images/static/ch5_p08/bush1.png"),
            new HLF.TextureAsset("bush2", "images/static/ch5_p08/bush2.png"),
            new HLF.TextureAsset("bushes", "images/static/ch5_p08/bushes.png"),
            new HLF.TextureAsset("frontbushes", "images/static/ch5_p08/frontbushes.png"),
            new HLF.TextureAsset("groundtile", "images/static/ch5_p08/groundtile.png"),
            new HLF.TextureAsset("hill", "images/static/ch5_p08/hill.png"),
            new HLF.TextureAsset("Layer0", "images/static/ch5_p08/Layer0.png"),
            new HLF.TextureAsset("Layer0copy", "images/static/ch5_p08/Layer0copy.png"),
            new HLF.TextureAsset("Layer1245", "images/static/ch5_p08/Layer1245.png"),
            new HLF.TextureAsset("Layer1246", "images/static/ch5_p08/Layer1246.png"),
            new HLF.TextureAsset("Layer1247", "images/static/ch5_p08/Layer1247.png"),
            new HLF.TextureAsset("Layer1248", "images/static/ch5_p08/Layer1248.png"),
            new HLF.TextureAsset("mooing", "images/static/ch5_p08/mooing.png"),
            new HLF.TextureAsset("neutral", "images/static/ch5_p08/neutral.png"),
            new HLF.TextureAsset("Body", "images/static/ch5_p08/Body.png"),
            new HLF.TextureAsset("Farmer", "images/static/ch5_p08/Farmer.png"),
            new HLF.TextureAsset("hood", "images/static/ch5_p08/hood.png"),
            new HLF.TextureAsset("wheels", "images/static/ch5_p08/wheels.png"),
            new HLF.SpineAsset("holly-horse", HLF.AssetType.SPINE_JSON, "holly-horse"),

            new HLF.AudioAsset("HH_Ch5_Holly_On_Horseback_LoopB_P6-9", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch5_p09", [
            new HLF.TextureAsset("ch5_p09_bg", "images/static/ch5_p09/ch5_p09_bg.png"),
            new HLF.TextureAsset("ch5_p09_hollyhorse", "images/static/ch5_p09/ch5_p09_hollyhorse.png"),
            new HLF.TextureAsset("ch5_p09_tyler", "images/static/ch5_p09/ch5_p09_tyler.png"),
            new HLF.TextureAsset("ch5_p09/Lframe", "images/static/ch5_p09/Lframe.png"),
            new HLF.TextureAsset("ch5_p09/llines", "images/static/ch5_p09/llines.png"),
            new HLF.TextureAsset("ch5_p09/Rframe", "images/static/ch5_p09/Rframe.png"),
            new HLF.TextureAsset("ch5_p09/rlines", "images/static/ch5_p09/rlines.png"),

            new HLF.AudioAsset("HH_Ch5_Holly_On_Horseback_LoopB_P6-9", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch5_p10", [
            new HLF.TextureAsset("ch5_p10/rlines", "images/static/ch5_p10/rlines.png"),
            new HLF.TextureAsset("ch5_p10_actionlines", "images/static/ch5_p10/ch5_p10_actionlines.png"),
            new HLF.TextureAsset("ch5_p10_balloonp1", "images/static/ch5_p10/ch5_p10_balloonp1.png"),
            new HLF.TextureAsset("ch5_p10_balloonp2", "images/static/ch5_p10/ch5_p10_balloonp2.png"),
            new HLF.TextureAsset("ch5_p10_balloonr1", "images/static/ch5_p10/ch5_p10_balloonr1.png"),
            new HLF.TextureAsset("ch5_p10_balloonr2", "images/static/ch5_p10/ch5_p10_balloonr2.png"),
            new HLF.TextureAsset("ch5_p10_balloony1", "images/static/ch5_p10/ch5_p10_balloony1.png"),
            new HLF.TextureAsset("ch5_p10_balloony2", "images/static/ch5_p10/ch5_p10_balloony2.png"),
            new HLF.TextureAsset("ch5_p10_bg", "images/static/ch5_p10/ch5_p10_bg.png"),
            new HLF.TextureAsset("ch5_p10_bird", "images/static/ch5_p10/ch5_p10_bird.png"),
            new HLF.TextureAsset("ch5_p10_branch", "images/static/ch5_p10/ch5_p10_branch.png"),
            new HLF.TextureAsset("ch5_p10_piece1", "images/static/ch5_p10/ch5_p10_piece1.png"),
            new HLF.TextureAsset("ch5_p10_piece2", "images/static/ch5_p10/ch5_p10_piece2.png"),
            new HLF.TextureAsset("ch5_p10_pop", "images/static/ch5_p10/ch5_p10_pop.png"),
            new HLF.TextureAsset("ch5_p10_popback", "images/static/ch5_p10/ch5_p10_popback.png"),
            new HLF.TextureAsset("ch5_p10_popfront", "images/static/ch5_p10/ch5_p10_popfront.png"),
            new HLF.TextureAsset("ch5_p10_treeback", "images/static/ch5_p10/ch5_p10_treeback.png"),
            new HLF.TextureAsset("ch5_p10_treefront1", "images/static/ch5_p10/ch5_p10_treefront1.png"),
            new HLF.TextureAsset("ch5_p10_treefront2", "images/static/ch5_p10/ch5_p10_treefront2.png"),
            new HLF.TextureAsset("ch5_p10/Lframe", "images/static/ch5_p10/Lframe.png"),
            new HLF.TextureAsset("ch5_p10/llines", "images/static/ch5_p10/llines.png"),
            new HLF.TextureAsset("ch5_p10/Rframe", "images/static/ch5_p10/Rframe.png"),

            new HLF.AudioAsset("HH_Ch5_Balloon_Tension_P10-11", HLF.AudioCategory.BGM),

        ]);

        HLF.AssetMap.addAssetGroup("ch5_p12", [
            new HLF.TextureAsset("ch5_p12/Rframe", "images/static/ch5_p12/Rframe.png"),
            new HLF.TextureAsset("ch5_p12_actionlines", "images/static/ch5_p12/ch5_p12_actionlines.png"),
            new HLF.TextureAsset("ch5_p12_balloon1", "images/static/ch5_p12/ch5_p12_balloon1.png"),
            new HLF.TextureAsset("ch5_p12_balloon2", "images/static/ch5_p12/ch5_p12_balloon2.png"),
            new HLF.TextureAsset("ch5_p12_balloon3", "images/static/ch5_p12/ch5_p12_balloon3.png"),
            new HLF.TextureAsset("ch5_p12_balloon4", "images/static/ch5_p12/ch5_p12_balloon4.png"),
            new HLF.TextureAsset("ch5_p12_bg", "images/static/ch5_p12/ch5_p12_bg.png"),
            new HLF.TextureAsset("ch5_p12_hollyhorse", "images/static/ch5_p12/ch5_p12_hollyhorse.png"),
            new HLF.TextureAsset("ch5_p12/Lframe", "images/static/ch5_p12/Lframe.png"),

            new HLF.AudioAsset("HH_Ch5_Balloon_Tension_P10-11", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch5_p13", [
            new HLF.TextureAsset("ch5_p13_balloons", "images/static/ch5_p13/ch5_p13_balloons.png"),
            new HLF.TextureAsset("ch5_p13_bg", "images/static/ch5_p13/ch5_p13_bg.png"),
            new HLF.TextureAsset("ch5_p13_tree1", "images/static/ch5_p13/ch5_p13_tree1.png"),
            new HLF.TextureAsset("ch5_p13_tyler", "images/static/ch5_p13/ch5_p13_tyler.png"),
            new HLF.TextureAsset("ch5_p13/Lframe", "images/static/ch5_p13/Lframe.png"),
            new HLF.TextureAsset("ch5_p13/Llines", "images/static/ch5_p13/Llines.png"),
            new HLF.TextureAsset("ch5_p13/Rframe", "images/static/ch5_p13/Rframe.png"),
            new HLF.TextureAsset("ch5_p13/Rline", "images/static/ch5_p13/Rline.png"),

            new HLF.AudioAsset("HH_Ch5_Balloon_Tension_P10-11", HLF.AudioCategory.BGM),
        ]);
        HLF.AssetMap.addAssetGroup("ch5_p14", [
            new HLF.TextureAsset("ch5_p14_ballongreen", "images/static/ch5_p14/ch5_p14_ballongreen.png"),
            new HLF.TextureAsset("ch5_p14_balloonblue", "images/static/ch5_p14/ch5_p14_balloonblue.png"),
            new HLF.TextureAsset("ch5_p14_balloonlblue", "images/static/ch5_p14/ch5_p14_balloonlblue.png"),
            new HLF.TextureAsset("ch5_p14_balloonred", "images/static/ch5_p14/ch5_p14_balloonred.png"),
            new HLF.TextureAsset("ch5_p14_balloonyellow", "images/static/ch5_p14/ch5_p14_balloonyellow.png"),
            new HLF.TextureAsset("ch5_p14_bg", "images/static/ch5_p14/ch5_p14_bg.png"),
            new HLF.TextureAsset("ch5_p14_bushfront", "images/static/ch5_p14/ch5_p14_bushfront.png"),
            new HLF.TextureAsset("ch5_p14_holly", "images/static/ch5_p14/ch5_p14_holly.png"),
            new HLF.TextureAsset("ch5_p14_horse", "images/static/ch5_p14/ch5_p14_horse.png"),
            new HLF.TextureAsset("ch5_p14_tyler", "images/static/ch5_p14/ch5_p14_tyler.png"),
            new HLF.TextureAsset("ch5_p15_balloons", "images/static/ch5_p14/ch5_p15_balloons.png"),
            new HLF.TextureAsset("ch5_p15_holly", "images/static/ch5_p14/ch5_p15_holly.png"),
            new HLF.TextureAsset("ch5_p15_tylerback", "images/static/ch5_p14/ch5_p15_tylerback.png"),
            new HLF.TextureAsset("ch5_p15_tylerfront", "images/static/ch5_p14/ch5_p15_tylerfront.png"),
            new HLF.TextureAsset("Grass", "images/static/ch5_p14/Grass.png"),
            new HLF.TextureAsset("ch5_p14/Lframe", "images/static/ch5_p14/Lframe.png"),
            new HLF.TextureAsset("ch5_p14/Lline", "images/static/ch5_p14/Lline.png"),
            new HLF.TextureAsset("ch5_p14/Rframe", "images/static/ch5_p14/Rframe.png"),
            new HLF.TextureAsset("ch5_p14/rline", "images/static/ch5_p14/rline.png"),

            new HLF.AudioAsset("HH_Ch5_Balloon_Tension_P10-11", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch5_p16", [
            new HLF.TextureAsset("ch5_p16_balloons", "images/static/ch5_p16/ch5_p16_balloons.png"),
            new HLF.TextureAsset("ch5_p16_bg", "images/static/ch5_p16/ch5_p16_bg.png"),
            new HLF.TextureAsset("ch5_p16_holly", "images/static/ch5_p16/ch5_p16_holly.png"),
            new HLF.TextureAsset("ch5_p16_tyler", "images/static/ch5_p16/ch5_p16_tyler.png"),
            new HLF.TextureAsset("ch5_p17_balloons", "images/static/ch5_p16/ch5_p17_balloons.png"),
            new HLF.TextureAsset("ch5_p17_holly", "images/static/ch5_p16/ch5_p17_holly.png"),
            new HLF.TextureAsset("ch5_p17_rainoverlay", "images/static/ch5_p16/ch5_p17_rainoverlay.png"),
            new HLF.TextureAsset("ch5_p17_tyler", "images/static/ch5_p16/ch5_p17_tyler.png"),
            new HLF.TextureAsset("ch5_p16/Layer248", "images/static/ch5_p16/Layer248.png"),
            new HLF.TextureAsset("ch5_p16/Lframe", "images/static/ch5_p16/Lframe.png"),
            new HLF.TextureAsset("RainMockup", "images/static/ch5_p16/RainMockup.png"),
            new HLF.TextureAsset("ch5_p16/Rframe", "images/static/ch5_p16/Rframe.png"),
            new HLF.TextureAsset("ch5_p16/rlines", "images/static/ch5_p16/rlines.png"),

            new HLF.AudioAsset("HH_Ch5_Holly_Tyler_InRain_Intro_P16", HLF.AudioCategory.BGM),
            new HLF.AudioAsset("HH_Ch5_Holly_Tyler_InRain_LoopC_P16-17", HLF.AudioCategory.BGM),
        ]);

        // Chapter 6
        HLF.AssetMap.addAssetGroup("ch6_title", [
            new HLF.TextureAsset("title-bg", "images/static/titles/title-bg.jpg"),
            new HLF.TextureAsset("hh_chaptertitle-ch6", "images/static/titles/hh_chaptertitle-ch6.png"),
            new HLF.TextureAsset("play-button", "images/static/titles/play-button.png"),

            new HLF.AudioAsset("HH_Ch5_Holly_Tyler_InRain_Intro_P16", HLF.AudioCategory.BGM),
            new HLF.AudioAsset("HH_Ch5_Holly_Tyler_InRain_LoopC_P16-17", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p01", [
            new HLF.TextureAsset("chp6_p01_bg", "images/static/ch6_p01/chp6_p01_bg.png"),
            new HLF.TextureAsset("chp6_p01_bushes", "images/static/ch6_p01/chp6_p01_bushes.png"),
            new HLF.TextureAsset("chp6_p01_holly", "images/static/ch6_p01/chp6_p01_holly.png"),
            new HLF.TextureAsset("chp6_p01_horse", "images/static/ch6_p01/chp6_p01_horse.png"),
            new HLF.TextureAsset("chp6_p01_maintree", "images/static/ch6_p01/chp6_p01_maintree.png"),
            new HLF.TextureAsset("chp6_p01_path", "images/static/ch6_p01/chp6_p01_path.png"),
            new HLF.TextureAsset("chp6_p01_tyler", "images/static/ch6_p01/chp6_p01_tyler.png"),
            new HLF.TextureAsset("ch6_p01/Lframe", "images/static/ch6_p01/Lframe.png"),
            new HLF.TextureAsset("ch6_p01/llines", "images/static/ch6_p01/llines.png"),
            new HLF.TextureAsset("ch6_p01/rain1", "images/static/ch6_p01/rain1.png"),
            new HLF.TextureAsset("ch6_p01/rain2", "images/static/ch6_p01/rain2.png"),
            new HLF.TextureAsset("ch6_p01/Rframe", "images/static/ch6_p01/Rframe.png"),
            new HLF.TextureAsset("ch6_p01/rlineas", "images/static/ch6_p01/rlineas.png"),

            new HLF.AudioAsset("HH_Ch5_Holly_Tyler_InRain_Intro_P16", HLF.AudioCategory.BGM),
            new HLF.AudioAsset("HH_Ch5_Holly_Tyler_InRain_LoopC_P16-17", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p02", [
            new HLF.TextureAsset("chp6_p02_bg", "images/static/ch6_p02/chp6_p02_bg.png"),
            new HLF.TextureAsset("chp6_p02_gift", "images/static/ch6_p02/chp6_p02_gift.png"),
            new HLF.TextureAsset("chp6_p02_holly", "images/static/ch6_p02/chp6_p02_holly.png"),
            new HLF.TextureAsset("chp6_p02_horse", "images/static/ch6_p02/chp6_p02_horse.png"),
            new HLF.TextureAsset("chp6_p02_tyler", "images/static/ch6_p02/chp6_p02_tyler.png"),
            new HLF.TextureAsset("ch6_p02/Lframe", "images/static/ch6_p02/Lframe.png"),
            new HLF.TextureAsset("ch6_p02/llines", "images/static/ch6_p02/llines.png"),
            new HLF.TextureAsset("ch6_p02/rain1", "images/static/ch6_p02/rain1.png"),
            new HLF.TextureAsset("ch6_p02/rain2", "images/static/ch6_p02/rain2.png"),
            new HLF.TextureAsset("ch6_p02/Rframe", "images/static/ch6_p02/Rframe.png"),
            new HLF.TextureAsset("ch6_p02/rlines", "images/static/ch6_p02/rlines.png"),
            new HLF.TextureAsset("lower", "images/static/ch6_p02/lower.png"),
            new HLF.TextureAsset("pocket", "images/static/ch6_p02/pocket.png"),
            new HLF.TextureAsset("drops", "images/static/ch6_p02/drops.png"),

            new HLF.AudioAsset("HH_Ch5_Holly_Tyler_InRain_LoopC_P16-17", HLF.AudioCategory.BGM),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p03", [
            new HLF.TextureAsset("chp6_p03_bg", "images/static/ch6_p03/chp6_p03_bg.png"),
            new HLF.TextureAsset("chp6_p03_holly", "images/static/ch6_p03/chp6_p03_holly.png"),
            new HLF.TextureAsset("chp6_p03_horse", "images/static/ch6_p03/chp6_p03_horse.png"),
            new HLF.TextureAsset("chp6_p03_tyler", "images/static/ch6_p03/chp6_p03_tyler.png"),
            new HLF.TextureAsset("ch6_p03/Lframe", "images/static/ch6_p03/Lframe.png"),
            new HLF.TextureAsset("ch6_p03/Llineart", "images/static/ch6_p03/Llineart.png"),
            new HLF.TextureAsset("ch6_p03/rain1", "images/static/ch6_p03/rain1.png"),
            new HLF.TextureAsset("ch6_p03/rain2", "images/static/ch6_p03/rain2.png"),
            new HLF.TextureAsset("ch6_p03/Rframe", "images/static/ch6_p03/Rframe.png"),
            new HLF.TextureAsset("ch6_p03/Rlineart", "images/static/ch6_p03/Rlineart.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p04", [
            new HLF.TextureAsset("chp6_p04_bg", "images/static/ch6_p04/chp6_p04_bg.png"),
            new HLF.TextureAsset("chp6_p04_hollyarms", "images/static/ch6_p04/chp6_p04_hollyarms.png"),
            new HLF.TextureAsset("chp6_p04_hollybody", "images/static/ch6_p04/chp6_p04_hollybody.png"),
            new HLF.TextureAsset("ch6_p04/Layer331", "images/static/ch6_p04/Layer331.png"),
            new HLF.TextureAsset("ch6_p04/Lframe", "images/static/ch6_p04/Lframe.png"),
            new HLF.TextureAsset("ch6_p04/rain1", "images/static/ch6_p04/rain1.png"),
            new HLF.TextureAsset("ch6_p04/rain2", "images/static/ch6_p04/rain2.png"),
            new HLF.TextureAsset("ch6_p04/Rframe", "images/static/ch6_p04/Rframe.png"),
            new HLF.TextureAsset("ch6_p04/Rlines", "images/static/ch6_p04/Rlines.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p05", [
            new HLF.TextureAsset("1", "images/static/ch6_p05/1.png"),
            new HLF.TextureAsset("2", "images/static/ch6_p05/2.png"),
            new HLF.TextureAsset("3", "images/static/ch6_p05/3.png"),
            new HLF.TextureAsset("4", "images/static/ch6_p05/4.png"),
            new HLF.TextureAsset("bg", "images/static/ch6_p05/bg.png"),
            new HLF.TextureAsset("ch6_p05/Lframe", "images/static/ch6_p05/Lframe.png"),
            new HLF.TextureAsset("ch6_p05/Rframe", "images/static/ch6_p05/Rframe.png"),
            new HLF.TextureAsset("tails1_2Pulled", "images/static/ch6_p05/tails1_2Pulled.png"),
            new HLF.TextureAsset("tailsdefault", "images/static/ch6_p05/tailsdefault.png"),
            new HLF.TextureAsset("tailspulled", "images/static/ch6_p05/tailspulled.png"),
            new HLF.TextureAsset("Ltail1", "images/static/ch6_p05/Ltail1.png"),
            new HLF.TextureAsset("Rtail1", "images/static/ch6_p05/Rtail1.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p07", [
            new HLF.TextureAsset("chp6_p07_holly", "images/static/ch6_p07/chp6_p07_holly.png"),
            new HLF.TextureAsset("chp6_p07_bg", "images/static/ch6_p07/chp6_p07_bg.png"),
            new HLF.TextureAsset("chp6_p07_horse", "images/static/ch6_p07/chp6_p07_horse.png"),
            new HLF.TextureAsset("chp6_p07_tyler", "images/static/ch6_p07/chp6_p07_tyler.png"),
            new HLF.TextureAsset("chp6_p07_tylerfront", "images/static/ch6_p07/chp6_p07_tylerfront.png"),
            new HLF.TextureAsset("chp6_p08_holly", "images/static/ch6_p07/chp6_p08_holly.png"),
            new HLF.TextureAsset("chp6_p08_horse", "images/static/ch6_p07/chp6_p08_horse.png"),
            new HLF.TextureAsset("chp6_p08_tyler", "images/static/ch6_p07/chp6_p08_tyler.png"),
            new HLF.TextureAsset("chp6_p08_tylerfront", "images/static/ch6_p07/chp6_p08_tylerfront.png"),
            new HLF.TextureAsset("chp6_p09_holly", "images/static/ch6_p07/chp6_p09_holly.png"),
            new HLF.TextureAsset("chp6_p09_horse", "images/static/ch6_p07/chp6_p09_horse.png"),
            new HLF.TextureAsset("chp6_p09_tyler", "images/static/ch6_p07/chp6_p09_tyler.png"),
            new HLF.TextureAsset("chp6_p09_tylerfront", "images/static/ch6_p07/chp6_p09_tylerfront.png"),
            new HLF.TextureAsset("chp6_p09b_holly", "images/static/ch6_p07/chp6_p09b_holly.png"),
            new HLF.TextureAsset("chp6_p09b_horse", "images/static/ch6_p07/chp6_p09b_horse.png"),
            new HLF.TextureAsset("chp6_p09b_tyler", "images/static/ch6_p07/chp6_p09b_tyler.png"),
            new HLF.TextureAsset("chp6_p09b_tylerfront", "images/static/ch6_p07/chp6_p09b_tylerfront.png"),
            new HLF.TextureAsset("ch6_p07/Lframe", "images/static/ch6_p07/Lframe.png"),
            new HLF.TextureAsset("ch6_p07/lline", "images/static/ch6_p07/lline.png"),
            new HLF.TextureAsset("ch6_p07/rain1", "images/static/ch6_p07/rain1.png"),
            new HLF.TextureAsset("ch6_p07/rain2", "images/static/ch6_p07/rain2.png"),
            new HLF.TextureAsset("ch6_p07/Rframe", "images/static/ch6_p07/Rframe.png"),
            new HLF.TextureAsset("ch6_p07/rline", "images/static/ch6_p07/rline.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p10", [
            new HLF.TextureAsset("Layer241", "images/static/ch6_p10/Layer241.png"),
            new HLF.TextureAsset("chp6_p10_bg", "images/static/ch6_p10/chp6_p10_bg.png"),
            new HLF.TextureAsset("chp6_p10_l", "images/static/ch6_p10/chp6_p10_l.png"),
            new HLF.TextureAsset("chp6_p10_r", "images/static/ch6_p10/chp6_p10_r.png"),
            new HLF.TextureAsset("chp6_p10_rstroke", "images/static/ch6_p10/chp6_p10_rstroke.png"),
            new HLF.TextureAsset("Layer9copy", "images/static/ch6_p10/Layer9copy.png"),
            new HLF.TextureAsset("ch6_p10/Lframe", "images/static/ch6_p10/Lframe.png"),
            new HLF.TextureAsset("ch6_p10/Rframe", "images/static/ch6_p10/Rframe.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p11", [
            new HLF.TextureAsset("chp6_p11_bg", "images/static/ch6_p11/chp6_p11_bg.png"),
            new HLF.TextureAsset("chp6_p11_holly", "images/static/ch6_p11/chp6_p11_holly.png"),
            new HLF.TextureAsset("chp6_p11_horse", "images/static/ch6_p11/chp6_p11_horse.png"),
            new HLF.TextureAsset("chp6_p11_tyler", "images/static/ch6_p11/chp6_p11_tyler.png"),
            new HLF.TextureAsset("ch6_p11/Lframe", "images/static/ch6_p11/Lframe.png"),
            new HLF.TextureAsset("ch6_p11/lline", "images/static/ch6_p11/lline.png"),
            new HLF.TextureAsset("ch6_p11/rain1", "images/static/ch6_p11/rain1.png"),
            new HLF.TextureAsset("ch6_p11/rain2", "images/static/ch6_p11/rain2.png"),
            new HLF.TextureAsset("ch6_p11/Rframe", "images/static/ch6_p11/Rframe.png"),
            new HLF.TextureAsset("ch6_p11/rline", "images/static/ch6_p11/rline.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p12", [
            new HLF.TextureAsset("chp6_p12_bg", "images/static/ch6_p12/chp6_p12_bg.png"),
            new HLF.TextureAsset("chp6_p12_hands", "images/static/ch6_p12/chp6_p12_hands.png"),
            new HLF.TextureAsset("chp6_p12_rain", "images/static/ch6_p12/chp6_p12_rain.png"),
            new HLF.TextureAsset("chp6_p12_sparkle11", "images/static/ch6_p12/chp6_p12_sparkle11.png"),
            new HLF.TextureAsset("chp6_p12_sparkle12", "images/static/ch6_p12/chp6_p12_sparkle12.png"),
            new HLF.TextureAsset("chp6_p12_sparkle13", "images/static/ch6_p12/chp6_p12_sparkle13.png"),
            new HLF.TextureAsset("chp6_p12_sparkle14", "images/static/ch6_p12/chp6_p12_sparkle14.png"),
            new HLF.TextureAsset("chp6_p12_sparkle21", "images/static/ch6_p12/chp6_p12_sparkle21.png"),
            new HLF.TextureAsset("chp6_p12_sparkle22", "images/static/ch6_p12/chp6_p12_sparkle22.png"),
            new HLF.TextureAsset("chp6_p12_sparkle23", "images/static/ch6_p12/chp6_p12_sparkle23.png"),
            new HLF.TextureAsset("chp6_p12_sparkle24", "images/static/ch6_p12/chp6_p12_sparkle24.png"),
            new HLF.TextureAsset("chp6_p12_sparkle31", "images/static/ch6_p12/chp6_p12_sparkle31.png"),
            new HLF.TextureAsset("chp6_p12_sparkle32", "images/static/ch6_p12/chp6_p12_sparkle32.png"),
            new HLF.TextureAsset("chp6_p12_sparkle33", "images/static/ch6_p12/chp6_p12_sparkle33.png"),
            new HLF.TextureAsset("chp6_p12_sparkle34", "images/static/ch6_p12/chp6_p12_sparkle34.png"),
            new HLF.TextureAsset("glow", "images/static/ch6_p12/glow.png"),
            new HLF.TextureAsset("ch6_p12/Lframe", "images/static/ch6_p12/Lframe.png"),
            new HLF.TextureAsset("ch6_p12/Rframe", "images/static/ch6_p12/Rframe.png"),
            new HLF.TextureAsset("sparkles", "images/static/ch6_p12/sparkles.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p13", [
            new HLF.TextureAsset("chp6_p13_bg", "images/static/ch6_p13/chp6_p13_bg.png"),
            new HLF.TextureAsset("chp6_p13_horse", "images/static/ch6_p13/chp6_p13_horse.png"),
            new HLF.TextureAsset("chp6_p13_tylerholly", "images/static/ch6_p13/chp6_p13_tylerholly.png"),
            new HLF.TextureAsset("Layer349", "images/static/ch6_p13/Layer349.png"),
            new HLF.TextureAsset("Layer349copy", "images/static/ch6_p13/Layer349copy.png"),
            new HLF.TextureAsset("Layer350", "images/static/ch6_p13/Layer350.png"),
            new HLF.TextureAsset("ch6_p13/Lframe", "images/static/ch6_p13/Lframe.png"),
            new HLF.TextureAsset("ch6_p13/lline", "images/static/ch6_p13/lline.png"),
            new HLF.TextureAsset("ch6_p13/rain1", "images/static/ch6_p13/rain1.png"),
            new HLF.TextureAsset("ch6_p13/rain2", "images/static/ch6_p13/rain2.png"),
            new HLF.TextureAsset("ch6_p13/Rframe", "images/static/ch6_p13/Rframe.png"),
            new HLF.TextureAsset("ch6_p13/rline", "images/static/ch6_p13/rline.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p14", [
            new HLF.TextureAsset("chp6_p14_horse", "images/static/ch6_p14/chp6_p14_horse.png"),
            new HLF.TextureAsset("chp6_p14_bg", "images/static/ch6_p14/chp6_p14_bg.png"),
            new HLF.TextureAsset("chp6_p14_holly", "images/static/ch6_p14/chp6_p14_holly.png"),
            new HLF.TextureAsset("chp6_p14_ringbg", "images/static/ch6_p14/chp6_p14_ringbg.png"),
            new HLF.TextureAsset("chp6_p14_tyler", "images/static/ch6_p14/chp6_p14_tyler.png"),
            new HLF.TextureAsset("chp6_p15_holly", "images/static/ch6_p14/chp6_p15_holly.png"),
            new HLF.TextureAsset("chp6_p15_horse", "images/static/ch6_p14/chp6_p15_horse.png"),
            new HLF.TextureAsset("chp6_p15_tyler", "images/static/ch6_p14/chp6_p15_tyler.png"),
            new HLF.TextureAsset("ch6_p14/g_1", "images/static/ch6_p14/g_1.png"),
            new HLF.TextureAsset("ch6_p14/g", "images/static/ch6_p14/g.png"),
            new HLF.TextureAsset("ch6_p14/i_1", "images/static/ch6_p14/i_1.png"),
            new HLF.TextureAsset("ch6_p14/i_2", "images/static/ch6_p14/i_2.png"),
            new HLF.TextureAsset("ch6_p14/i", "images/static/ch6_p14/i.png"),
            new HLF.TextureAsset("ch6_p14/Lframe", "images/static/ch6_p14/Lframe.png"),
            new HLF.TextureAsset("ch6_p14/n_1", "images/static/ch6_p14/n_1.png"),
            new HLF.TextureAsset("ch6_p14/n", "images/static/ch6_p14/n.png"),
            new HLF.TextureAsset("ch6_p14/r_1", "images/static/ch6_p14/r_1.png"),
            new HLF.TextureAsset("ch6_p14/r_2", "images/static/ch6_p14/r_2.png"),
            new HLF.TextureAsset("ch6_p14/r_3", "images/static/ch6_p14/r_3.png"),
            new HLF.TextureAsset("ch6_p14/r", "images/static/ch6_p14/r.png"),
            new HLF.TextureAsset("ch6_p14/rain1", "images/static/ch6_p14/rain1.png"),
            new HLF.TextureAsset("ch6_p14/rain2", "images/static/ch6_p14/rain2.png"),
            new HLF.TextureAsset("ch6_p14/Rframe", "images/static/ch6_p14/Rframe.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p16", [
            new HLF.TextureAsset("chp6_p16_bg", "images/static/ch6_p16/chp6_p16_bg.png"),
            new HLF.TextureAsset("chp6_p16_holly", "images/static/ch6_p16/chp6_p16_holly.png"),
            new HLF.TextureAsset("chp6_p16_tyler", "images/static/ch6_p16/chp6_p16_tyler.png"),
            new HLF.TextureAsset("chp6_p17_handphone", "images/static/ch6_p16/chp6_p17_handphone.png"),
            new HLF.TextureAsset("chp6_p17_holly", "images/static/ch6_p16/chp6_p17_holly.png"),
            new HLF.TextureAsset("chp6_p17_tyler", "images/static/ch6_p16/chp6_p17_tyler.png"),
            new HLF.TextureAsset("ch6_p16/g_1", "images/static/ch6_p16/g_1.png"),
            new HLF.TextureAsset("ch6_p16/g_2", "images/static/ch6_p16/g_2.png"),
            new HLF.TextureAsset("ch6_p16/g", "images/static/ch6_p16/g.png"),
            new HLF.TextureAsset("ch6_p16/i_1", "images/static/ch6_p16/i_1.png"),
            new HLF.TextureAsset("ch6_p16/i", "images/static/ch6_p16/i.png"),
            new HLF.TextureAsset("ch6_p16/Layer584", "images/static/ch6_p16/Layer584.png"),
            new HLF.TextureAsset("ch6_p16/Layer585", "images/static/ch6_p16/Layer585.png"),
            new HLF.TextureAsset("ch6_p16/Lframe", "images/static/ch6_p16/Lframe.png"),
            new HLF.TextureAsset("ch6_p16/n_1", "images/static/ch6_p16/n_1.png"),
            new HLF.TextureAsset("ch6_p16/n", "images/static/ch6_p16/n.png"),
            new HLF.TextureAsset("ch6_p16/r_1", "images/static/ch6_p16/r_1.png"),
            new HLF.TextureAsset("ch6_p16/r_2", "images/static/ch6_p16/r_2.png"),
            new HLF.TextureAsset("ch6_p16/r", "images/static/ch6_p16/r.png"),
            new HLF.TextureAsset("ch6_p16/rain1", "images/static/ch6_p16/rain1.png"),
            new HLF.TextureAsset("ch6_p16/rain2", "images/static/ch6_p16/rain2.png"),
            new HLF.TextureAsset("ch6_p16/Rframe", "images/static/ch6_p16/Rframe.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch6_p18", [
            new HLF.TextureAsset("chp6_p18_bg", "images/static/ch6_p18/chp6_p18_bg.png"),
            new HLF.TextureAsset("chp6_p18_holly", "images/static/ch6_p18/chp6_p18_holly.png"),
            new HLF.TextureAsset("chp6_p18_horse", "images/static/ch6_p18/chp6_p18_horse.png"),
            new HLF.TextureAsset("helmet", "images/static/ch6_p18/helmet.png"),
            new HLF.TextureAsset("ch6_p18/Lframe", "images/static/ch6_p18/Lframe.png"),
            new HLF.TextureAsset("ch6_p18/llines", "images/static/ch6_p18/llines.png"),
            new HLF.TextureAsset("ch6_p18/Rframe", "images/static/ch6_p18/Rframe.png"),
            new HLF.TextureAsset("ch6_p18/rlineas", "images/static/ch6_p18/rlineas.png"),
        ]);

// chapter 7
        HLF.AssetMap.addAssetGroup("ch7_title", [
            new HLF.TextureAsset("title-bg", "images/static/titles/title-bg.jpg"),
            new HLF.TextureAsset("hh_chaptertitle-ch7", "images/static/titles/hh_chaptertitle-ch7.png"),
            new HLF.TextureAsset("play-button", "images/static/titles/play-button.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch7_p01", [
            new HLF.TextureAsset("chp7_p01_hollyhorse", "images/static/ch7_p01/chp7_p01_hollyhorse.png"),
            new HLF.TextureAsset("barnandstilo", "images/static/ch7_p01/barnandstilo.png"),
            new HLF.TextureAsset("bg", "images/static/ch7_p01/bg.png"),
            new HLF.TextureAsset("grassandpath", "images/static/ch7_p01/grassandpath.png"),
            new HLF.TextureAsset("grassbg", "images/static/ch7_p01/grassbg.png"),
            new HLF.TextureAsset("ch7_p01/Lframe", "images/static/ch7_p01/Lframe.png"),
            new HLF.TextureAsset("ch7_p01/Rframe", "images/static/ch7_p01/Rframe.png"),
            new HLF.TextureAsset("shadow", "images/static/ch7_p01/shadow.png"),
            new HLF.TextureAsset("sidebushes", "images/static/ch7_p01/sidebushes.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch7_p02", [
            new HLF.TextureAsset("chp7_p02_bg", "images/static/ch7_p02/chp7_p02_bg.png"),
            new HLF.TextureAsset("chp7_p02_holly", "images/static/ch7_p02/chp7_p02_holly.png"),
            new HLF.TextureAsset("chp7_p02_horse", "images/static/ch7_p02/chp7_p02_horse.png"),
            new HLF.TextureAsset("ch7_p02/Lframe", "images/static/ch7_p02/Lframe.png"),
            new HLF.TextureAsset("ch7_p02/llines", "images/static/ch7_p02/llines.png"),
            new HLF.TextureAsset("ch7_p02/Rframe", "images/static/ch7_p02/Rframe.png"),
            new HLF.TextureAsset("ch7_p02/rlines", "images/static/ch7_p02/rlines.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch7_p03", [
            new HLF.TextureAsset("chp7_p03_bg", "images/static/ch7_p03/chp7_p03_bg.png"),
            new HLF.TextureAsset("chp7_p03_bubble", "images/static/ch7_p03/chp7_p03_bubble.png"),
            new HLF.TextureAsset("chp7_p03_bubbleblurr", "images/static/ch7_p03/chp7_p03_bubbleblurr.png"),
            new HLF.TextureAsset("chp7_p03_holly", "images/static/ch7_p03/chp7_p03_holly.png"),
            new HLF.TextureAsset("ch7_p03/Lframe", "images/static/ch7_p03/Lframe.png"),
            new HLF.TextureAsset("ch7_p03/llines", "images/static/ch7_p03/llines.png"),
            new HLF.TextureAsset("ch7_p03/Rframe", "images/static/ch7_p03/Rframe.png"),
            new HLF.TextureAsset("ch7_p03/rlines", "images/static/ch7_p03/rlines.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch7_p05", [
            new HLF.TextureAsset("chp7_p05_bg", "images/static/ch7_p05/chp7_p05_bg.png"),
            new HLF.TextureAsset("chp7_p05_bushhouse", "images/static/ch7_p05/chp7_p05_bushhouse.png"),
            new HLF.TextureAsset("chp7_p05_holly", "images/static/ch7_p05/chp7_p05_holly.png"),
            new HLF.TextureAsset("ch7_p05/Layer944", "images/static/ch7_p05/Layer944.png"),
            new HLF.TextureAsset("ch7_p05/Lframe", "images/static/ch7_p05/Lframe.png"),
            new HLF.TextureAsset("ch7_p05/Rframe", "images/static/ch7_p05/Rframe.png"),
            new HLF.TextureAsset("ch7_p05/rlines", "images/static/ch7_p05/rlines.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch7_p06", [
            new HLF.TextureAsset("1", "images/static/ch7_p06/1.png"),
            new HLF.TextureAsset("2", "images/static/ch7_p06/2.png"),
            new HLF.TextureAsset("3", "images/static/ch7_p06/3.png"),
            new HLF.TextureAsset("chp7_p06_bg", "images/static/ch7_p06/chp7_p06_bg.png"),
            new HLF.TextureAsset("chp7_p06_holly", "images/static/ch7_p06/chp7_p06_holly.png"),
            new HLF.TextureAsset("ch7_p06/Lframe", "images/static/ch7_p06/Lframe.png"),
            new HLF.TextureAsset("ch7_p06/Rframe", "images/static/ch7_p06/Rframe.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch7_p07", [
            new HLF.TextureAsset("ch7_p07/Rlines", "images/static/ch7_p07/Rlines.png"),
            new HLF.TextureAsset("chp7_p07_apple1", "images/static/ch7_p07/chp7_p07_apple1.png"),
            new HLF.TextureAsset("chp7_p07_apple2", "images/static/ch7_p07/chp7_p07_apple2.png"),
            new HLF.TextureAsset("chp7_p07_apple3", "images/static/ch7_p07/chp7_p07_apple3.png"),
            new HLF.TextureAsset("chp7_p07_apple4", "images/static/ch7_p07/chp7_p07_apple4.png"),
            new HLF.TextureAsset("chp7_p07_bg", "images/static/ch7_p07/chp7_p07_bg.png"),
            new HLF.TextureAsset("chp7_p07_closedgate", "images/static/ch7_p07/chp7_p07_closedgate.png"),
            new HLF.TextureAsset("chp7_p07_holly", "images/static/ch7_p07/chp7_p07_holly.png"),
            new HLF.TextureAsset("chp7_p07_opengate", "images/static/ch7_p07/chp7_p07_opengate.png"),
            new HLF.TextureAsset("chp7_p07_satchelback", "images/static/ch7_p07/chp7_p07_satchelback.png"),
            new HLF.TextureAsset("chp7_p07_satchelfront", "images/static/ch7_p07/chp7_p07_satchelfront.png"),
            new HLF.TextureAsset("chp7_p07_taable", "images/static/ch7_p07/chp7_p07_taable.png"),
            new HLF.TextureAsset("ch7_p07/Lframe", "images/static/ch7_p07/Lframe.png"),
            new HLF.TextureAsset("ch7_p07/llines", "images/static/ch7_p07/llines.png"),
            new HLF.TextureAsset("ch7_p07/Rframe", "images/static/ch7_p07/Rframe.png"),
            new HLF.TextureAsset("sheep1", "images/static/ch7_p07/sheep1.png"),
            new HLF.TextureAsset("sheep2", "images/static/ch7_p07/sheep2.png"),
            new HLF.TextureAsset("sheep3", "images/static/ch7_p07/sheep3.png"),
            new HLF.TextureAsset("Sheepsizewhenenteringgate", "images/static/ch7_p07/Sheepsizewhenenteringgate.png"),
            new HLF.TextureAsset("chp7_p07_penfront", "images/static/ch7_p07/chp7_p07_penfront.png"),

            new HLF.SpineAsset("sheep", HLF.AssetType.SPINE_JSON, "sheep"),
            new HLF.TextureAsset("apple_eaten", "images/static/ch7_p07/apple_eaten.png"),
            new HLF.TextureAsset("apple_part_eaten", "images/static/ch7_p07/apple_part_eaten.png"),
            new HLF.TextureAsset("apple_whole", "images/static/ch7_p07/apple_whole.png"),
        ]);

        // chapter 8
        HLF.AssetMap.addAssetGroup("ch8_title", [
            new HLF.TextureAsset("title-bg", "images/static/titles/title-bg.jpg"),
            new HLF.TextureAsset("hh_chaptertitle-ch8", "images/static/titles/hh_chaptertitle-ch8.png"),
            new HLF.TextureAsset("play-button", "images/static/titles/play-button.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch8_p01", [
            new HLF.TextureAsset("_1", "images/static/ch8_p01/_1.png"),
            new HLF.TextureAsset("_2", "images/static/ch8_p01/_2.png"),
            new HLF.TextureAsset("_3", "images/static/ch8_p01/_3.png"),
            new HLF.TextureAsset("a_1", "images/static/ch8_p01/a_1.png"),
            new HLF.TextureAsset("a_2", "images/static/ch8_p01/a_2.png"),
            new HLF.TextureAsset("a_3", "images/static/ch8_p01/a_3.png"),
            new HLF.TextureAsset("a_4", "images/static/ch8_p01/a_4.png"),
            new HLF.TextureAsset("a_5", "images/static/ch8_p01/a_5.png"),
            new HLF.TextureAsset("a_6", "images/static/ch8_p01/a_6.png"),
            new HLF.TextureAsset("a_7", "images/static/ch8_p01/a_7.png"),
            new HLF.TextureAsset("a_8", "images/static/ch8_p01/a_8.png"),
            new HLF.TextureAsset("a", "images/static/ch8_p01/a.png"),
            new HLF.TextureAsset("b", "images/static/ch8_p01/b.png"),
            new HLF.TextureAsset("chp1_p01_bg", "images/static/ch8_p01/chp1_p01_bg.png"),
            new HLF.TextureAsset("chp8_p01_grass", "images/static/ch8_p01/chp8_p01_grass.png"),
            new HLF.TextureAsset("chp8_p01_holly", "images/static/ch8_p01/chp8_p01_holly.png"),
            new HLF.TextureAsset("chp8_p01_pen", "images/static/ch8_p01/chp8_p01_pen.png"),
            new HLF.TextureAsset("chp8_p01_textbg", "images/static/ch8_p01/chp8_p01_textbg.png"),
            new HLF.TextureAsset("ch8_p01/Lframe", "images/static/ch8_p01/Lframe.png"),
            new HLF.TextureAsset("ch8_p01/llines", "images/static/ch8_p01/llines.png"),
            new HLF.TextureAsset("ch8_p01/Rframe", "images/static/ch8_p01/Rframe.png"),
            new HLF.TextureAsset("ch8_p01/rlines", "images/static/ch8_p01/rlines.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch8_p02", [
            new HLF.TextureAsset("chp8_p02_bg", "images/static/ch8_p02/chp8_p02_bg.png"),
            new HLF.TextureAsset("chp8_p02_grass", "images/static/ch8_p02/chp8_p02_grass.png"),
            new HLF.TextureAsset("chp8_p02_holly", "images/static/ch8_p02/chp8_p02_holly.png"),
            new HLF.TextureAsset("chp8_p02_speedlines", "images/static/ch8_p02/chp8_p02_speedlines.png"),
            new HLF.TextureAsset("ch8_p02/L", "images/static/ch8_p02/L.png"),
            new HLF.TextureAsset("ch8_p02/Lframe", "images/static/ch8_p02/Lframe.png"),
            new HLF.TextureAsset("ch8_p02/R", "images/static/ch8_p02/R.png"),
            new HLF.TextureAsset("ch8_p02/Rframe", "images/static/ch8_p02/Rframe.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch8_p03", [
            new HLF.TextureAsset("chp8_p03_bg", "images/static/ch8_p03/chp8_p03_bg.png"),
            new HLF.TextureAsset("chp8_p03_bushes", "images/static/ch8_p03/chp8_p03_bushes.png"),
            new HLF.TextureAsset("chp8_p03_grass", "images/static/ch8_p03/chp8_p03_grass.png"),
            new HLF.TextureAsset("chp8_p03_holly", "images/static/ch8_p03/chp8_p03_holly.png"),
            new HLF.TextureAsset("chp8_p03_lamb", "images/static/ch8_p03/chp8_p03_lamb.png"),
            new HLF.TextureAsset("chp8_p03_treetop", "images/static/ch8_p03/chp8_p03_treetop.png"),
            new HLF.TextureAsset("ch8_p03/Lframe", "images/static/ch8_p03/Lframe.png"),
            new HLF.TextureAsset("ch8_p03/llines", "images/static/ch8_p03/llines.png"),
            new HLF.TextureAsset("ch8_p03/Rframe", "images/static/ch8_p03/Rframe.png"),
            new HLF.TextureAsset("ch8_p03/rlines", "images/static/ch8_p03/rlines.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch8_p04", [
            new HLF.TextureAsset("bg", "images/static/ch8_p04/bg.png"),
            new HLF.TextureAsset("foliage", "images/static/ch8_p04/foliage.png"),
            new HLF.TextureAsset("lamb", "images/static/ch8_p04/lamb.png"),
            new HLF.TextureAsset("ch8_p04/Lframe", "images/static/ch8_p04/Lframe.png"),
            new HLF.TextureAsset("ch8_p04/Rframe", "images/static/ch8_p04/Rframe.png"),
            new HLF.TextureAsset("trunk", "images/static/ch8_p04/trunk.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch8_p05", [
            new HLF.SpineAsset("holly-profile", HLF.AssetType.SPINE_JSON, "holly-profile"),
            new HLF.TextureAsset("chp8_p05_bg", "images/static/ch8_p05/chp8_p05_bg.png"),
            new HLF.TextureAsset("chp8_p05_bgcopy", "images/static/ch8_p05/chp8_p05_bgcopy.png"),
            new HLF.TextureAsset("chp8_p05_bgcopy2", "images/static/ch8_p05/chp8_p05_bgcopy2.png"),
            new HLF.TextureAsset("chp8_p05_midgrounda", "images/static/ch8_p05/chp8_p05_midgrounda.png"),
            new HLF.TextureAsset("chp8_p05_midgroundb", "images/static/ch8_p05/chp8_p05_midgroundb.png"),
            new HLF.TextureAsset("chp8_p05_midgroundc", "images/static/ch8_p05/chp8_p05_midgroundc.png"),
            new HLF.TextureAsset("WaterTile", "images/static/ch8_p05/WaterTile.png"),
            new HLF.TextureAsset("chp8_p05_lamb", "images/static/ch8_p05/chp8_p05_lamb.png"),
            new HLF.TextureAsset("chp8_p05_treeback", "images/static/ch8_p05/chp8_p05_treeback.png"),
            new HLF.TextureAsset("chp8_p05_treefront", "images/static/ch8_p05/chp8_p05_treefront.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch8_p06", [
            new HLF.TextureAsset("chp8_p06_background", "images/static/ch8_p06/chp8_p06_background.png"),
            new HLF.TextureAsset("chp8_p06_hollyarmscopy", "images/static/ch8_p06/chp8_p06_hollyarmscopy.png"),
            new HLF.TextureAsset("chp8_p06_hollycatch", "images/static/ch8_p06/chp8_p06_hollycatch.png"),
            new HLF.TextureAsset("chp8_p06_emptytire", "images/static/ch8_p06/chp8_p06_emptytire.png"),
            new HLF.TextureAsset("chp8_p06_lambintire", "images/static/ch8_p06/chp8_p06_lambintire.png"),
            new HLF.TextureAsset("chp8_p06_lamb1", "images/static/ch8_p06/chp8_p06_lamb1.png"),
            new HLF.TextureAsset("chp8_p06_lamb2", "images/static/ch8_p06/chp8_p06_lamb2.png"),
            new HLF.TextureAsset("chp8_p06_tree", "images/static/ch8_p06/chp8_p06_tree.png"),
            new HLF.TextureAsset("chp8_p06_treetop", "images/static/ch8_p06/chp8_p06_treetop.png"),
            new HLF.TextureAsset("chp8_p06_treetopforeground", "images/static/ch8_p06/chp8_p06_treetopforeground.png"),
            new HLF.TextureAsset("WaterFront", "images/static/ch8_p06/WaterFront.png"),
        ]);

        // chapter 9
        HLF.AssetMap.addAssetGroup("ch9_title", [
            new HLF.TextureAsset("title-bg", "images/static/titles/title-bg.jpg"),
            new HLF.TextureAsset("hh_chaptertitle-ch9", "images/static/titles/hh_chaptertitle-ch9.png"),
            new HLF.TextureAsset("play-button", "images/static/titles/play-button.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch9_p01", [
            new HLF.TextureAsset("chp9_p01_fence", "images/static/ch9_p01/chp9_p01_fence.png"),
            new HLF.TextureAsset("chp9_p01_bg", "images/static/ch9_p01/chp9_p01_bg.png"),
            new HLF.TextureAsset("chp9_p01_frontsheep", "images/static/ch9_p01/chp9_p01_frontsheep.png"),
            new HLF.TextureAsset("chp9_p01_holly", "images/static/ch9_p01/chp9_p01_holly.png"),
            new HLF.TextureAsset("chp9_p01_hollyfront", "images/static/ch9_p01/chp9_p01_hollyfront.png"),
            new HLF.TextureAsset("chp9_p01_hollymiddle", "images/static/ch9_p01/chp9_p01_hollymiddle.png"),
            new HLF.TextureAsset("chp9_p01_lamb", "images/static/ch9_p01/chp9_p01_lamb.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch9_p02", [
            new HLF.TextureAsset("chp9_p02_bg", "images/static/ch9_p02/chp9_p02_bg.png"),
            new HLF.TextureAsset("chp9_p02_holly", "images/static/ch9_p02/chp9_p02_holly.png"),
            new HLF.TextureAsset("chp9_p03_holly", "images/static/ch9_p02/chp9_p03_holly.png"),
            new HLF.TextureAsset("ch9_p02/Lframe", "images/static/ch9_p02/Lframe.png"),
            new HLF.TextureAsset("ch9_p02/Rframe", "images/static/ch9_p02/Rframe.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch9_p04", [
            new HLF.TextureAsset("chp9_p04_bg", "images/static/ch9_p04/chp9_p04_bg.png"),
            new HLF.TextureAsset("chp9_p04_holly", "images/static/ch9_p04/chp9_p04_holly.png"),
            new HLF.TextureAsset("chp9_p04_lanterns", "images/static/ch9_p04/chp9_p04_lanterns.png"),
            new HLF.TextureAsset("ch9_p04/Lframe", "images/static/ch9_p04/Lframe.png"),
            new HLF.TextureAsset("ch9_p04/Rframe", "images/static/ch9_p04/Rframe.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch9_p05", [
            new HLF.TextureAsset("barnbushes", "images/static/ch9_p05/barnbushes.png"),
            new HLF.TextureAsset("chp9_p05_bg", "images/static/ch9_p05/chp9_p05_bg.png"),
            new HLF.TextureAsset("chp9_p05_bgcopy", "images/static/ch9_p05/chp9_p05_bgcopy.png"),
            new HLF.TextureAsset("chp9_p05_holly1", "images/static/ch9_p05/chp9_p05_holly1.png"),
            new HLF.TextureAsset("chp9_p05_holly2", "images/static/ch9_p05/chp9_p05_holly2.png"),
            new HLF.TextureAsset("chp9_p05_holly3", "images/static/ch9_p05/chp9_p05_holly3.png"),
            new HLF.TextureAsset("chp9_p05_lanternboff", "images/static/ch9_p05/chp9_p05_lanternboff.png"),
            new HLF.TextureAsset("chp9_p05_lanternbon", "images/static/ch9_p05/chp9_p05_lanternbon.png"),
            new HLF.TextureAsset("chp9_p05_lanternroff", "images/static/ch9_p05/chp9_p05_lanternroff.png"),
            new HLF.TextureAsset("chp9_p05_lanternron", "images/static/ch9_p05/chp9_p05_lanternron.png"),
            new HLF.TextureAsset("chp9_p05_lanternshadow", "images/static/ch9_p05/chp9_p05_lanternshadow.png"),
            new HLF.TextureAsset("chp9_p05_lanternyoff", "images/static/ch9_p05/chp9_p05_lanternyoff.png"),
            new HLF.TextureAsset("chp9_p05_lanternyon", "images/static/ch9_p05/chp9_p05_lanternyon.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch9_p06", [
            new HLF.TextureAsset("chp9_p06_bg", "images/static/ch9_p06/chp9_p06_bg.png"),
            new HLF.TextureAsset("chp9_p06_holly", "images/static/ch9_p06/chp9_p06_holly.png"),
            new HLF.TextureAsset("ch9_p06/glow", "images/static/ch9_p06/glow.png"),
            new HLF.TextureAsset("ch9_p06/glowcopy", "images/static/ch9_p06/glowcopy.png"),
            new HLF.TextureAsset("ch9_p06/Layer32copy", "images/static/ch9_p06/Layer32copy.png"),
            new HLF.TextureAsset("ch9_p06/Layer94copy2", "images/static/ch9_p06/Layer94copy2.png"),
            new HLF.TextureAsset("ch9_p06/Layer95", "images/static/ch9_p06/Layer95.png"),
            new HLF.TextureAsset("ch9_p06/Layer95copy", "images/static/ch9_p06/Layer95copy.png"),
            new HLF.TextureAsset("ch9_p06/Lframe", "images/static/ch9_p06/Lframe.png"),
            new HLF.TextureAsset("ch9_p06/Rframe", "images/static/ch9_p06/Rframe.png"),
        ]);

        // chapter 10
        HLF.AssetMap.addAssetGroup("ch10_title", [
            new HLF.TextureAsset("title-bg", "images/static/titles/title-bg.jpg"),
            new HLF.TextureAsset("hh_chaptertitle-ch10", "images/static/titles/hh_chaptertitle-ch10.png"),
            new HLF.TextureAsset("play-button", "images/static/titles/play-button.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch10_p01", [
            new HLF.TextureAsset("chp10_p10_bg", "images/static/ch10_p01/chp10_p10_bg.png"),
            new HLF.TextureAsset("chp10_p10_characters", "images/static/ch10_p01/chp10_p10_characters.png"),
            new HLF.TextureAsset("ch10_p01/Layer77", "images/static/ch10_p01/Layer77.png"),
            new HLF.TextureAsset("ch10_p01/Layer77copy", "images/static/ch10_p01/Layer77copy.png"),
            new HLF.TextureAsset("ch10_p01/Layer78", "images/static/ch10_p01/Layer78.png"),
            new HLF.TextureAsset("ch10_p01/Layer78copy", "images/static/ch10_p01/Layer78copy.png"),
            new HLF.TextureAsset("ch10_p01/Layer79", "images/static/ch10_p01/Layer79.png"),
            new HLF.TextureAsset("ch10_p01/Layer79copy", "images/static/ch10_p01/Layer79copy.png"),
            new HLF.TextureAsset("ch10_p01/Lframe", "images/static/ch10_p01/Lframe.png"),
            new HLF.TextureAsset("ch10_p01/pink", "images/static/ch10_p01/pink.png"),
            new HLF.TextureAsset("ch10_p01/Rframe", "images/static/ch10_p01/Rframe.png"),
            new HLF.TextureAsset("ch10_p01/white", "images/static/ch10_p01/white.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch10_p02", [
            new HLF.TextureAsset("ch10_p02/Layer77copy", "images/static/ch10_p02/Layer77copy.png"),
            new HLF.TextureAsset("chp10_p02_bg", "images/static/ch10_p02/chp10_p02_bg.png"),
            new HLF.TextureAsset("chp10_p02_holly", "images/static/ch10_p02/chp10_p02_holly.png"),
            new HLF.TextureAsset("chp10_p03_holly", "images/static/ch10_p02/chp10_p03_holly.png"),
            new HLF.TextureAsset("ch10_p02/Layer57", "images/static/ch10_p02/Layer57.png"),
            new HLF.TextureAsset("ch10_p02/Layer59", "images/static/ch10_p02/Layer59.png"),
            new HLF.TextureAsset("ch10_p02/Layer60", "images/static/ch10_p02/Layer60.png"),
            new HLF.TextureAsset("ch10_p02/Layer61", "images/static/ch10_p02/Layer61.png"),
            new HLF.TextureAsset("ch10_p02/Layer62", "images/static/ch10_p02/Layer62.png"),
            new HLF.TextureAsset("ch10_p02/Layer63", "images/static/ch10_p02/Layer63.png"),
            new HLF.TextureAsset("ch10_p02/Layer78copy", "images/static/ch10_p02/Layer78copy.png"),
            new HLF.TextureAsset("ch10_p02/Layer79copy", "images/static/ch10_p02/Layer79copy.png"),
            new HLF.TextureAsset("ch10_p02/Layer135copy", "images/static/ch10_p02/Layer135copy.png"),
            new HLF.TextureAsset("ch10_p02/Lframe", "images/static/ch10_p02/Lframe.png"),
            new HLF.TextureAsset("ch10_p02/Rframe", "images/static/ch10_p02/Rframe.png"),
            new HLF.TextureAsset("texture", "images/static/ch10_p02/texture.png"),
        ]);

        HLF.AssetMap.addAssetGroup("ch10_p04", [
            new HLF.TextureAsset("chp10_p04_bg", "images/static/ch10_p04/chp10_p04_bg.png"),
            new HLF.TextureAsset("chp10_p04_characters", "images/static/ch10_p04/chp10_p04_characters.png"),
            new HLF.TextureAsset("chp10_p05_characters", "images/static/ch10_p04/chp10_p05_characters.png"),
            new HLF.TextureAsset("ch10_p04/Layer1", "images/static/ch10_p04/Layer1.png"),
            new HLF.TextureAsset("ch10_p04/Layer2", "images/static/ch10_p04/Layer2.png"),
            new HLF.TextureAsset("ch10_p04/Layer3", "images/static/ch10_p04/Layer3.png"),
            new HLF.TextureAsset("ch10_p04/Layer4", "images/static/ch10_p04/Layer4.png"),
            new HLF.TextureAsset("ch10_p04/Layer5", "images/static/ch10_p04/Layer5.png"),
            new HLF.TextureAsset("ch10_p04/Layer77copy", "images/static/ch10_p04/Layer77copy.png"),
            new HLF.TextureAsset("ch10_p04/Layer78copy", "images/static/ch10_p04/Layer78copy.png"),
            new HLF.TextureAsset("ch10_p04/Layer79copy", "images/static/ch10_p04/Layer79copy.png"),
            new HLF.TextureAsset("ch10_p04/Lframe", "images/static/ch10_p04/Lframe.png"),
            new HLF.TextureAsset("ch10_p04/Rframe", "images/static/ch10_p04/Rframe.png"),
        ]);
    }

    protected registerLoadingScreens(): void {
        this._loadManager.registerLoadScreen(
            Constants.LOAD_INTERSTITIAL, new Interstitial());
        this._loadManager.registerLoadScreen(
            StoryLoadScreen.NAME, () => new StoryLoadScreen());
    }

    protected registerPopups(): void {
        this._popupManager.registerPopup(() => new MusicGameSharePopup(), Constants.POPUP_MUSIC_SHARE);
        this._popupManager.registerPopup(() => new PausePopup(), "pause");
    }

    protected registerStates(): void {
        this._stateManager.registerState(Constants.STATE_LANDING_PAGE, () => new LandingPage({ next: Constants.STATE_MENU }));
        this._stateManager.registerState(Constants.STATE_MENU, () => new MainMenu());
        this._stateManager.registerState(Constants.STATE_GAME, () => new MusicGame());
        this._stateManager.registerState(Constants.STATE_PLAYBACK, () => new MusicGamePlayback());
        this._stateManager.registerState("ch1_menu", () => new ChapterMenu({ chapter: 1, pages: ["01", "03", "06", "07", "08", "09", "10", "11", "14", "17"], next: "ch2_menu" }));
        this._stateManager.registerState("ch2_menu", () => new ChapterMenu({ chapter: 2, pages: ["01", "02", "03", "04", "05", "08"], next: "ch3_menu" }));
        this._stateManager.registerState("ch3_menu", () => new ChapterMenu({ chapter: 3, pages: ["01", "02", "03", "06", "08"], next: "ch4_menu" }));
        this._stateManager.registerState("ch4_menu", () => new ChapterMenu({ chapter: 4, pages: ["01", "02", "05", "06", "08", "09", "10"], next: "ch5_menu" }));
        this._stateManager.registerState("ch5_menu", () => new ChapterMenu({ chapter: 5, pages: ["01", "03", "04", "06", "07", "08", "09", "10", "12", "13", "14", "16"], next: "ch6_menu" }));
        this._stateManager.registerState("ch6_menu", () => new ChapterMenu({ chapter: 6, pages: ["01", "02", "03", "04", "05", "07", "10", "11", "12", "13", "14", "16", "18"], next: "ch7_menu" }));
        this._stateManager.registerState("ch7_menu", () => new ChapterMenu({ chapter: 7, pages: ["01", "02", "03", "05", "06", "07"], next: "ch8_menu" }));
        this._stateManager.registerState("ch8_menu", () => new ChapterMenu({ chapter: 8, pages: ["01", "02", "03", "04", "05", "06"], next: "ch9_menu" }));
        this._stateManager.registerState("ch9_menu", () => new ChapterMenu({ chapter: 9, pages: ["01", "02", "04", "05", "06"], next: "ch10_menu" }));
        this._stateManager.registerState("ch10_menu", () => new ChapterMenu({ chapter: 10, pages: ["01", "02", "04"] }));

        this._stateManager.registerState("ch1_title", () => new ChapterTitleScreen({
            image: "hh_chaptertitle-ch1",
            next: "ch1_p01",
        }));
        this._stateManager.registerState("ch1_p01", () => new Chapter1Page1({ next: "ch1_p03" }));
        this._stateManager.registerState("ch1_p03", () => new Chapter1Page3({ next: "ch1_p06" }));
        this._stateManager.registerState("ch1_p06", () => new Chapter1Page6({ next: "ch1_p07" }));
        this._stateManager.registerState("ch1_p07", () => new Chapter1Page7({ next: "ch1_p08" }));
        this._stateManager.registerState("ch1_p08", () => new Chapter1Page8({ next: "ch1_p09" }));
        this._stateManager.registerState("ch1_p09", () => new Chapter1Page9({ next: "ch1_p10" }));
        this._stateManager.registerState("ch1_p10", () => new Chapter1Page10({ next: "ch1_p11" }));
        this._stateManager.registerState("ch1_p11", () => new Chapter1Page11({ next: "ch1_p14" }));
        this._stateManager.registerState("ch1_p14", () => new Chapter1Page14({ next: "ch1_p17" }));
        this._stateManager.registerState("ch1_p17", () => new Chapter1Page17({ next: "ch2_title" }));

        this._stateManager.registerState("ch2_title", () => new ChapterTitleScreen({
            image: "hh_chaptertitle-ch2",
            next: "ch2_p01",
        }));
        this._stateManager.registerState("ch2_p01", () => new Chapter2Page1({ next: "ch2_p02" }));
        this._stateManager.registerState("ch2_p02", () => new Chapter2Page2({ next: "ch2_p03" }));
        this._stateManager.registerState("ch2_p03", () => new Chapter2Page3({ next: "ch2_p04" }));
        this._stateManager.registerState("ch2_p04", () => new Chapter2Page4({ next: "ch2_p05" }));
        this._stateManager.registerState("ch2_p05", () => new Chapter2Page5({ next: "ch2_p08" }));
        this._stateManager.registerState("ch2_p08", () => new Chapter2Page8({ next: "ch3_title" }));

        this._stateManager.registerState("ch3_title", () => new ChapterTitleScreen({
            image: "hh_chaptertitle-ch3",
            next: "ch3_p01",
        }));
        this._stateManager.registerState("ch3_p01", () => new Chapter3Page1({ next: "ch3_p02" }));
        this._stateManager.registerState("ch3_p02", () => new Chapter3Page2({ next: "ch3_p03" }));
        this._stateManager.registerState("ch3_p03", () => new Chapter3Page3({ next: "ch3_p06" }));
        this._stateManager.registerState("ch3_p06", () => new Chapter3Page6({ next: "ch3_p08" }));
        this._stateManager.registerState("ch3_p08", () => new Chapter3Page8({ next: "ch4_title" }));

        this._stateManager.registerState("ch4_title", () => new ChapterTitleScreen({
            image: "hh_chaptertitle-ch4",
            next: "ch4_p01",
        }));
        this._stateManager.registerState("ch4_p01", () => new Chapter4Page1({ next: "ch4_p02" }));
        this._stateManager.registerState("ch4_p02", () => new Chapter4Page2({ next: "ch4_p05" }));
        this._stateManager.registerState("ch4_p05", () => new Chapter4Page5({ next: "ch4_p06" }));
        this._stateManager.registerState("ch4_p06", () => new Chapter4Page6({ next: "ch4_p08" }));
        this._stateManager.registerState("ch4_p08", () => new Chapter4Page8({ next: "ch4_p09" }));
        this._stateManager.registerState("ch4_p09", () => new Chapter4Page9({ next: "ch4_p10" }));
        this._stateManager.registerState("ch4_p10", () => new Chapter4Page10({ next: "ch5_title" }));

        this._stateManager.registerState("ch5_title", () => new ChapterTitleScreen({
            image: "hh_chaptertitle-ch5",
            next: "ch5_p01",
        }));
        this._stateManager.registerState("ch5_p01", () => new Chapter5Page1({ next: "ch5_p03" }));
        this._stateManager.registerState("ch5_p03", () => new Chapter5Page3({ next: "ch5_p04" }));
        this._stateManager.registerState("ch5_p04", () => new Chapter5Page4({ next: "ch5_p06" }));
        this._stateManager.registerState("ch5_p06", () => new Chapter5Page6({ next: "ch5_p07" }));
        this._stateManager.registerState("ch5_p07", () => new Chapter5Page7({ next: "ch5_p08" }));
        this._stateManager.registerState("ch5_p08", () => new Chapter5Page8({ next: "ch5_p09" }));
        this._stateManager.registerState("ch5_p09", () => new Chapter5Page9({ next: "ch5_p10" }));
        this._stateManager.registerState("ch5_p10", () => new Chapter5Page10({ next: "ch5_p12" }));
        this._stateManager.registerState("ch5_p12", () => new Chapter5Page12({ next: "ch5_p13" }));
        this._stateManager.registerState("ch5_p13", () => new Chapter5Page13({ next: "ch5_p14" }));
        this._stateManager.registerState("ch5_p14", () => new Chapter5Page14({ next: "ch5_p16" }));
        this._stateManager.registerState("ch5_p16", () => new Chapter5Page16({ next: "ch6_title" }));

        this._stateManager.registerState("ch6_title", () => new ChapterTitleScreen({
            image: "hh_chaptertitle-ch6",
            next: "ch6_p01",
        }));
        this._stateManager.registerState("ch6_p01", () => new Chapter6Page1({ next: "ch6_p02" }));
        this._stateManager.registerState("ch6_p02", () => new Chapter6Page2({ next: "ch6_p03" }));
        this._stateManager.registerState("ch6_p03", () => new Chapter6Page3({ next: "ch6_p04" }));
        this._stateManager.registerState("ch6_p04", () => new Chapter6Page4({ next: "ch6_p05" }));
        this._stateManager.registerState("ch6_p05", () => new Chapter6Page5({ next: "ch6_p07" }));
        this._stateManager.registerState("ch6_p07", () => new Chapter6Page7({ next: "ch6_p10" }));
        this._stateManager.registerState("ch6_p10", () => new Chapter6Page10({ next: "ch6_p11" }));
        this._stateManager.registerState("ch6_p11", () => new Chapter6Page11({ next: "ch6_p12" }));
        this._stateManager.registerState("ch6_p12", () => new Chapter6Page12({ next: "ch6_p13" }));
        this._stateManager.registerState("ch6_p13", () => new Chapter6Page13({ next: "ch6_p14" }));
        this._stateManager.registerState("ch6_p14", () => new Chapter6Page14({ next: "ch6_p16" }));
        this._stateManager.registerState("ch6_p16", () => new Chapter6Page16({ next: "ch6_p18" }));
        this._stateManager.registerState("ch6_p18", () => new Chapter6Page18({ next: "ch7_title" }));

        this._stateManager.registerState("ch7_title", () => new ChapterTitleScreen({
            image: "hh_chaptertitle-ch7",
            next: "ch7_p01",
        }));

        this._stateManager.registerState("ch7_p01", () => new Chapter7Page1({ next: "ch7_p02" }));
        this._stateManager.registerState("ch7_p02", () => new Chapter7Page2({ next: "ch7_p03" }));
        this._stateManager.registerState("ch7_p03", () => new Chapter7Page3({ next: "ch7_p05" }));
        this._stateManager.registerState("ch7_p05", () => new Chapter7Page5({ next: "ch7_p06" }));
        this._stateManager.registerState("ch7_p06", () => new Chapter7Page6({ next: "ch7_p07" }));
        this._stateManager.registerState("ch7_p07", () => new Chapter7Page7({ next: "ch8_title" }));

        this._stateManager.registerState("ch8_title", () => new ChapterTitleScreen({
            image: "hh_chaptertitle-ch8",
            next: "ch8_p01",
        }));

        this._stateManager.registerState("ch8_p01", () => new Chapter8Page1({ next: "ch8_p02" }));
        this._stateManager.registerState("ch8_p02", () => new Chapter8Page2({ next: "ch8_p03" }));
        this._stateManager.registerState("ch8_p03", () => new Chapter8Page3({ next: "ch8_p04" }));
        this._stateManager.registerState("ch8_p04", () => new Chapter8Page4({ next: "ch8_p05" }));
        this._stateManager.registerState("ch8_p05", () => new Chapter8Page5({ next: "ch8_p06" }));
        this._stateManager.registerState("ch8_p06", () => new Chapter8Page6({ next: "ch9_title" }));

        this._stateManager.registerState("ch9_title", () => new ChapterTitleScreen({
            image: "hh_chaptertitle-ch9",
            next: "ch9_p01",
        }));

        this._stateManager.registerState("ch9_p01", () => new Chapter9Page1({ next: "ch9_p02" }));
        this._stateManager.registerState("ch9_p02", () => new Chapter9Page2({ next: "ch9_p04" }));
        this._stateManager.registerState("ch9_p04", () => new Chapter9Page4({ next: "ch9_p05" }));
        this._stateManager.registerState("ch9_p05", () => new Chapter9Page5({ next: "ch9_p06" }));
        this._stateManager.registerState("ch9_p06", () => new Chapter9Page6({ next: "ch10_title" }));

        this._stateManager.registerState("ch10_title", () => new ChapterTitleScreen({
            image: "hh_chaptertitle-ch10",
            next: "ch10_p01",
        }));

        this._stateManager.registerState("ch10_p01", () => new Chapter10Page1({ next: "ch10_p02" }));
        this._stateManager.registerState("ch10_p02", () => new Chapter10Page2({ next: "ch10_p04" }));
        this._stateManager.registerState("ch10_p04", () => new Chapter10Page4({ next: "ch1_menu" }));
    }

    // Splash view is visible and all required assets have been loaded.
    protected onLoadRequiredAssetsComplete(): void {
        super.onLoadRequiredAssetsComplete();

        this._loaded = true;

        this.stage.addChild(new HLF.Input.KeyboardFocusManager(KeyboardFocus));

        this._audioManager.setCategoryVolume(HLF.AudioCategory.SFX.toString(), 0.3);
        this._audioManager.setCategoryVolume(Constants.AUDIO_CATEGORY_SOLO.toString(), 1);
        this._audioManager.setCategoryVolume(HLF.AudioCategory.BGM.toString(), 0.3);

        if (Constants.DEBUG_DEFAULT_STATE === undefined) {
            PubSub.publishSync(HLF.STATE_LOAD_STATE, new HLF.StateToken(
                Constants.STATE_LANDING_PAGE, HLF.SplashScreen.NAME, ...HLF.StateToken.TRANSITION_FIRST_VIEW,
            ));
        }
        else {
            PubSub.publishSync(HLF.STATE_LOAD_STATE, new HLF.StateToken(
                { id: Constants.DEBUG_DEFAULT_STATE, data: { name: Constants.DEBUG_DEFAULT_STATE } },
                Constants.LOAD_INTERSTITIAL,
                HLF.TransitionStep.LoadAssets,
                HLF.TransitionStep.HideLoadScreen,
                HLF.TransitionStep.AttachNewInFront,
                HLF.TransitionStep.AnimNewIn,
            ));
        }
    }

    private onPause(pIsPaused: boolean): void {
        console.log("paused: " + pIsPaused);
        const wasPaused = this._paused;
        if (pIsPaused && !wasPaused) {
            PubSub.publishSync(HLF.GAME_PAUSED, undefined);
            PIXI.spine.Spine.globalAutoUpdate = false;
            PIXI.Ticker.shared.stop();
            TweenMax.globalTimeScale(0);
            PubSub.publishSync(HLF.SHOW_POPUP, new HLF.PopupToken("pause", ()=>this.onPause(false), true, true));
        }
        else if (wasPaused && !pIsPaused) {
            PubSub.publishSync(HLF.HIDE_POPUP, "pause");
            TweenMax.globalTimeScale(1);
            PIXI.Ticker.shared.start();
            PIXI.spine.Spine.globalAutoUpdate = true;
            PubSub.publishSync(HLF.GAME_UNPAUSED, undefined);
        }
        this._paused = pIsPaused;
    }
}
